// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { fieldMaskFromJson, fieldMaskToJson } from '../../vendastatypes/codec';
export function currenciesToJson(m) {
    const o = {};
    return o;
}
export function currenciesFromJson(o) {
    return {};
}
export function frequenciesToJson(m) {
    const o = {};
    return o;
}
export function frequenciesFromJson(o) {
    return {};
}
export function permissionListsToJson(m) {
    const o = {};
    if (m.whitelist !== undefined) {
        o['whitelist'] = m.whitelist.map(e => e);
    }
    if (m.blacklist !== undefined) {
        o['blacklist'] = m.blacklist.map(e => e);
    }
    return o;
}
export function permissionListsFromJson(o) {
    var _a, _b;
    return {
        whitelist: ((_a = o['whitelist']) !== null && _a !== void 0 ? _a : []).map(e => e),
        blacklist: ((_b = o['blacklist']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function restrictionsToJson(m) {
    const o = {};
    if (m.country !== undefined)
        o['country'] = permissionListsToJson(m.country);
    return o;
}
export function restrictionsFromJson(o) {
    return {
        country: o['country'] ? permissionListsFromJson(o['country']) : undefined,
    };
}
export function lmiToJson(m) {
    const o = {};
    return o;
}
export function lmiFromJson(o) {
    return {};
}
export function serviceModelToJson(m) {
    const o = {};
    return o;
}
export function serviceModelFromJson(o) {
    return {};
}
export function frequentlyAskedQuestionsToJson(m) {
    const o = {};
    if (m.question !== undefined)
        o['question'] = m.question;
    if (m.answer !== undefined)
        o['answer'] = m.answer;
    return o;
}
export function frequentlyAskedQuestionsFromJson(o) {
    var _a, _b;
    return {
        question: (_a = o['question']) !== null && _a !== void 0 ? _a : '',
        answer: (_b = o['answer']) !== null && _b !== void 0 ? _b : '',
    };
}
export function productToJson(m) {
    const o = {};
    if (m.productId !== undefined)
        o['productId'] = m.productId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.tagline !== undefined)
        o['tagline'] = m.tagline;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.keySellingPoints !== undefined) {
        o['keySellingPoints'] = m.keySellingPoints.map(e => e);
    }
    if (m.iconUrl !== undefined)
        o['iconUrl'] = m.iconUrl;
    if (m.headerImageUrl !== undefined)
        o['headerImageUrl'] = m.headerImageUrl;
    if (m.screenshotUrls !== undefined) {
        o['screenshotUrls'] = m.screenshotUrls.map(e => e);
    }
    if (m.pdfUploadUrls !== undefined) {
        o['pdfUploadUrls'] = m.pdfUploadUrls.map(e => e);
    }
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.wholesalePrice !== undefined)
        o['wholesalePrice'] = m.wholesalePrice;
    if (m.recommendedSellPrice !== undefined)
        o['recommendedSellPrice'] = m.recommendedSellPrice;
    if (m.billingFrequency !== undefined)
        o['billingFrequency'] = m.billingFrequency;
    if (m.serviceModel !== undefined) {
        o['serviceModel'] = m.serviceModel.map(e => e);
    }
    if (m.category !== undefined)
        o['category'] = m.category;
    if (m.lmiCategories !== undefined) {
        o['lmiCategories'] = m.lmiCategories.map(e => e);
    }
    if (m.origin !== undefined)
        o['origin'] = m.origin;
    if (m.usesCustomizationForm !== undefined)
        o['usesCustomizationForm'] = m.usesCustomizationForm;
    if (m.entryUrl !== undefined)
        o['entryUrl'] = m.entryUrl;
    if (m.sessionUrl !== undefined)
        o['sessionUrl'] = m.sessionUrl;
    if (m.websiteUrl !== undefined)
        o['websiteUrl'] = m.websiteUrl;
    if (m.updatedBy !== undefined)
        o['updatedBy'] = m.updatedBy;
    if (m.endDate !== undefined)
        o['endDate'] = m.endDate.toISOString();
    if (m.faqs !== undefined) {
        o['faqs'] = m.faqs.map(e => frequentlyAskedQuestionsToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.isArchived !== undefined)
        o['isArchived'] = m.isArchived;
    if (m.restrictions !== undefined)
        o['restrictions'] = restrictionsToJson(m.restrictions);
    if (m.billingId !== undefined)
        o['billingId'] = m.billingId;
    if (m.usesActivationSpecificEntryUrl !== undefined)
        o['usesActivationSpecificEntryUrl'] = m.usesActivationSpecificEntryUrl;
    if (m.state !== undefined)
        o['state'] = m.state;
    if (m.setupFee !== undefined)
        o['setupFee'] = m.setupFee;
    if (m.suspended !== undefined)
        o['suspended'] = m.suspended.toISOString();
    if (m.usesCustomPricing !== undefined)
        o['usesCustomPricing'] = m.usesCustomPricing;
    return o;
}
export function productFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    return {
        productId: (_a = o['productId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
        tagline: (_d = o['tagline']) !== null && _d !== void 0 ? _d : '',
        description: (_e = o['description']) !== null && _e !== void 0 ? _e : '',
        keySellingPoints: ((_f = o['keySellingPoints']) !== null && _f !== void 0 ? _f : []).map(e => e),
        iconUrl: (_g = o['iconUrl']) !== null && _g !== void 0 ? _g : '',
        headerImageUrl: (_h = o['headerImageUrl']) !== null && _h !== void 0 ? _h : '',
        screenshotUrls: ((_j = o['screenshotUrls']) !== null && _j !== void 0 ? _j : []).map(e => e),
        pdfUploadUrls: ((_k = o['pdfUploadUrls']) !== null && _k !== void 0 ? _k : []).map(e => e),
        currency: (_l = o['currency']) !== null && _l !== void 0 ? _l : 'USD',
        wholesalePrice: (_m = o['wholesalePrice']) !== null && _m !== void 0 ? _m : '',
        recommendedSellPrice: (_o = o['recommendedSellPrice']) !== null && _o !== void 0 ? _o : '',
        billingFrequency: (_p = o['billingFrequency']) !== null && _p !== void 0 ? _p : '',
        serviceModel: ((_q = o['serviceModel']) !== null && _q !== void 0 ? _q : []).map(e => e),
        category: (_r = o['category']) !== null && _r !== void 0 ? _r : '',
        lmiCategories: ((_s = o['lmiCategories']) !== null && _s !== void 0 ? _s : []).map(e => e),
        origin: (_t = o['origin']) !== null && _t !== void 0 ? _t : '',
        usesCustomizationForm: (_u = o['usesCustomizationForm']) !== null && _u !== void 0 ? _u : false,
        entryUrl: (_v = o['entryUrl']) !== null && _v !== void 0 ? _v : '',
        sessionUrl: (_w = o['sessionUrl']) !== null && _w !== void 0 ? _w : '',
        websiteUrl: (_x = o['websiteUrl']) !== null && _x !== void 0 ? _x : '',
        updatedBy: (_y = o['updatedBy']) !== null && _y !== void 0 ? _y : '',
        endDate: o['endDate'] ? new Date(o['endDate']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        faqs: ((_z = o['faqs']) !== null && _z !== void 0 ? _z : []).map(e => frequentlyAskedQuestionsFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        isArchived: (_0 = o['isArchived']) !== null && _0 !== void 0 ? _0 : false,
        restrictions: o['restrictions'] ? restrictionsFromJson(o['restrictions']) : undefined,
        billingId: (_1 = o['billingId']) !== null && _1 !== void 0 ? _1 : '',
        usesActivationSpecificEntryUrl: (_2 = o['usesActivationSpecificEntryUrl']) !== null && _2 !== void 0 ? _2 : false,
        state: (_3 = o['state']) !== null && _3 !== void 0 ? _3 : 'STATE_INVALID',
        setupFee: (_4 = o['setupFee']) !== null && _4 !== void 0 ? _4 : 0,
        suspended: o['suspended'] ? new Date(o['suspended']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        usesCustomPricing: (_5 = o['usesCustomPricing']) !== null && _5 !== void 0 ? _5 : false,
    };
}
export function marketingInformationToJson(m) {
    const o = {};
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.keySellingPoints !== undefined) {
        o['keySellingPoints'] = m.keySellingPoints.map(e => e);
    }
    if (m.faqs !== undefined) {
        o['faqs'] = m.faqs.map(e => frequentlyAskedQuestionsToJson(e));
    }
    if (m.files !== undefined) {
        o['files'] = m.files.map(e => e);
    }
    return o;
}
export function marketingInformationFromJson(o) {
    var _a, _b, _c, _d;
    return {
        description: (_a = o['description']) !== null && _a !== void 0 ? _a : '',
        keySellingPoints: ((_b = o['keySellingPoints']) !== null && _b !== void 0 ? _b : []).map(e => e),
        faqs: ((_c = o['faqs']) !== null && _c !== void 0 ? _c : []).map(e => frequentlyAskedQuestionsFromJson(e)),
        files: ((_d = o['files']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function orderFormFieldToJson(m) {
    const o = {};
    if (m.label !== undefined)
        o['label'] = m.label;
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.options !== undefined) {
        o['options'] = m.options.map(e => e);
    }
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.required !== undefined)
        o['required'] = m.required;
    if (m.prefix !== undefined)
        o['prefix'] = m.prefix;
    if (m.suffix !== undefined)
        o['suffix'] = m.suffix;
    if (m.regexValidator !== undefined)
        o['regexValidator'] = m.regexValidator;
    if (m.regexErrorMessage !== undefined)
        o['regexErrorMessage'] = m.regexErrorMessage;
    return o;
}
export function orderFormFieldFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        label: (_a = o['label']) !== null && _a !== void 0 ? _a : '',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
        type: (_c = o['type']) !== null && _c !== void 0 ? _c : '',
        options: ((_d = o['options']) !== null && _d !== void 0 ? _d : []).map(e => e),
        description: (_e = o['description']) !== null && _e !== void 0 ? _e : '',
        required: (_f = o['required']) !== null && _f !== void 0 ? _f : false,
        prefix: (_g = o['prefix']) !== null && _g !== void 0 ? _g : '',
        suffix: (_h = o['suffix']) !== null && _h !== void 0 ? _h : '',
        regexValidator: (_j = o['regexValidator']) !== null && _j !== void 0 ? _j : '',
        regexErrorMessage: (_k = o['regexErrorMessage']) !== null && _k !== void 0 ? _k : '',
    };
}
export function includedCommonFormFieldsToJson(m) {
    const o = {};
    if (m.businessName !== undefined)
        o['businessName'] = m.businessName;
    if (m.businessAddress !== undefined)
        o['businessAddress'] = m.businessAddress;
    if (m.businessPhoneNumber !== undefined)
        o['businessPhoneNumber'] = m.businessPhoneNumber;
    if (m.businessAccountGroupId !== undefined)
        o['businessAccountGroupId'] = m.businessAccountGroupId;
    if (m.salespersonName !== undefined)
        o['salespersonName'] = m.salespersonName;
    if (m.salespersonPhoneNumber !== undefined)
        o['salespersonPhoneNumber'] = m.salespersonPhoneNumber;
    if (m.salespersonEmail !== undefined)
        o['salespersonEmail'] = m.salespersonEmail;
    if (m.contactName !== undefined)
        o['contactName'] = m.contactName;
    if (m.contactPhoneNumber !== undefined)
        o['contactPhoneNumber'] = m.contactPhoneNumber;
    if (m.contactEmail !== undefined)
        o['contactEmail'] = m.contactEmail;
    return o;
}
export function includedCommonFormFieldsFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        businessName: (_a = o['businessName']) !== null && _a !== void 0 ? _a : false,
        businessAddress: (_b = o['businessAddress']) !== null && _b !== void 0 ? _b : false,
        businessPhoneNumber: (_c = o['businessPhoneNumber']) !== null && _c !== void 0 ? _c : false,
        businessAccountGroupId: (_d = o['businessAccountGroupId']) !== null && _d !== void 0 ? _d : false,
        salespersonName: (_e = o['salespersonName']) !== null && _e !== void 0 ? _e : false,
        salespersonPhoneNumber: (_f = o['salespersonPhoneNumber']) !== null && _f !== void 0 ? _f : false,
        salespersonEmail: (_g = o['salespersonEmail']) !== null && _g !== void 0 ? _g : false,
        contactName: (_h = o['contactName']) !== null && _h !== void 0 ? _h : false,
        contactPhoneNumber: (_j = o['contactPhoneNumber']) !== null && _j !== void 0 ? _j : false,
        contactEmail: (_k = o['contactEmail']) !== null && _k !== void 0 ? _k : false,
    };
}
export function orderFormToJson(m) {
    const o = {};
    if (m.orderForm !== undefined) {
        o['orderForm'] = m.orderForm.map(e => orderFormFieldToJson(e));
    }
    if (m.commonForm !== undefined)
        o['commonForm'] = includedCommonFormFieldsToJson(m.commonForm);
    if (m.activationMessage !== undefined)
        o['activationMessage'] = m.activationMessage;
    if (m.separateOrderForms !== undefined)
        o['separateOrderForms'] = m.separateOrderForms;
    return o;
}
export function orderFormFromJson(o) {
    var _a, _b, _c;
    return {
        orderForm: ((_a = o['orderForm']) !== null && _a !== void 0 ? _a : []).map(e => orderFormFieldFromJson(e)),
        commonForm: o['commonForm'] ? includedCommonFormFieldsFromJson(o['commonForm']) : undefined,
        activationMessage: (_b = o['activationMessage']) !== null && _b !== void 0 ? _b : '',
        separateOrderForms: (_c = o['separateOrderForms']) !== null && _c !== void 0 ? _c : false,
    };
}
export function addonToJson(m) {
    const o = {};
    if (m.addonId !== undefined)
        o['addonId'] = m.addonId;
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.tagline !== undefined)
        o['tagline'] = m.tagline;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.approved !== undefined)
        o['approved'] = m.approved;
    if (m.icon !== undefined)
        o['icon'] = m.icon;
    if (m.bannerImage !== undefined)
        o['bannerImage'] = m.bannerImage;
    if (m.endUserMarketing !== undefined)
        o['endUserMarketing'] = marketingInformationToJson(m.endUserMarketing);
    if (m.serviceModel !== undefined) {
        o['serviceModel'] = m.serviceModel.map(e => e);
    }
    if (m.discoverable !== undefined)
        o['discoverable'] = m.discoverable;
    if (m.screenshots !== undefined) {
        o['screenshots'] = m.screenshots.map(e => e);
    }
    if (m.multipleActivations !== undefined)
        o['multipleActivations'] = m.multipleActivations;
    if (m.usesOrderForm !== undefined)
        o['usesOrderForm'] = m.usesOrderForm;
    if (m.billingFrequency !== undefined)
        o['billingFrequency'] = m.billingFrequency;
    if (m.resellerMarketing !== undefined)
        o['resellerMarketing'] = marketingInformationToJson(m.resellerMarketing);
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.orderForm !== undefined)
        o['orderForm'] = orderFormToJson(m.orderForm);
    if (m.price !== undefined)
        o['price'] = m.price;
    if (m.restrictions !== undefined)
        o['restrictions'] = restrictionsToJson(m.restrictions);
    if (m.activationRequiresApproval !== undefined)
        o['activationRequiresApproval'] = m.activationRequiresApproval;
    if (m.billingId !== undefined)
        o['billingId'] = m.billingId;
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.setupFee !== undefined)
        o['setupFee'] = m.setupFee;
    if (m.suspended !== undefined)
        o['suspended'] = m.suspended.toISOString();
    if (m.usesCustomPricing !== undefined)
        o['usesCustomPricing'] = m.usesCustomPricing;
    return o;
}
export function addonFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    return {
        addonId: (_a = o['addonId']) !== null && _a !== void 0 ? _a : '',
        appId: (_b = o['appId']) !== null && _b !== void 0 ? _b : '',
        tagline: (_c = o['tagline']) !== null && _c !== void 0 ? _c : '',
        title: (_d = o['title']) !== null && _d !== void 0 ? _d : '',
        approved: (_e = o['approved']) !== null && _e !== void 0 ? _e : false,
        icon: (_f = o['icon']) !== null && _f !== void 0 ? _f : '',
        bannerImage: (_g = o['bannerImage']) !== null && _g !== void 0 ? _g : '',
        endUserMarketing: o['endUserMarketing'] ? marketingInformationFromJson(o['endUserMarketing']) : undefined,
        serviceModel: ((_h = o['serviceModel']) !== null && _h !== void 0 ? _h : []).map(e => e),
        discoverable: (_j = o['discoverable']) !== null && _j !== void 0 ? _j : false,
        screenshots: ((_k = o['screenshots']) !== null && _k !== void 0 ? _k : []).map(e => e),
        multipleActivations: (_l = o['multipleActivations']) !== null && _l !== void 0 ? _l : false,
        usesOrderForm: (_m = o['usesOrderForm']) !== null && _m !== void 0 ? _m : false,
        billingFrequency: (_o = o['billingFrequency']) !== null && _o !== void 0 ? _o : '',
        resellerMarketing: o['resellerMarketing'] ? marketingInformationFromJson(o['resellerMarketing']) : undefined,
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        orderForm: o['orderForm'] ? orderFormFromJson(o['orderForm']) : undefined,
        price: (_p = o['price']) !== null && _p !== void 0 ? _p : 0,
        restrictions: o['restrictions'] ? restrictionsFromJson(o['restrictions']) : undefined,
        activationRequiresApproval: (_q = o['activationRequiresApproval']) !== null && _q !== void 0 ? _q : false,
        billingId: (_r = o['billingId']) !== null && _r !== void 0 ? _r : '',
        currency: (_s = o['currency']) !== null && _s !== void 0 ? _s : '',
        setupFee: (_t = o['setupFee']) !== null && _t !== void 0 ? _t : 0,
        suspended: o['suspended'] ? new Date(o['suspended']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        usesCustomPricing: (_u = o['usesCustomPricing']) !== null && _u !== void 0 ? _u : false,
    };
}
export function retailPriceToJson(m) {
    const o = {};
    if (m.price !== undefined)
        o['price'] = m.price;
    if (m.billingFrequency !== undefined)
        o['billingFrequency'] = m.billingFrequency;
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.setupFee !== undefined)
        o['setupFee'] = m.setupFee;
    return o;
}
export function retailPriceFromJson(o) {
    var _a, _b, _c, _d;
    return {
        price: (_a = o['price']) !== null && _a !== void 0 ? _a : 0,
        billingFrequency: (_b = o['billingFrequency']) !== null && _b !== void 0 ? _b : 'MONTHLY',
        currency: (_c = o['currency']) !== null && _c !== void 0 ? _c : 'USD',
        setupFee: (_d = o['setupFee']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function statusesToJson(m) {
    const o = {};
    return o;
}
export function statusesFromJson(o) {
    return {};
}
export function appEnablementStatusesToJson(m) {
    const o = {};
    return o;
}
export function appEnablementStatusesFromJson(o) {
    return {};
}
export function addonKeyToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.addonId !== undefined)
        o['addonId'] = m.addonId;
    if (m.quantity !== undefined)
        o['quantity'] = m.quantity;
    return o;
}
export function addonKeyFromJson(o) {
    var _a, _b, _c;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        addonId: (_b = o['addonId']) !== null && _b !== void 0 ? _b : '',
        quantity: (_c = o['quantity']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function priceToJson(m) {
    const o = {};
    if (m.price !== undefined)
        o['price'] = m.price;
    if (m.frequency !== undefined)
        o['frequency'] = m.frequency;
    if (m.isStartingPrice !== undefined)
        o['isStartingPrice'] = m.isStartingPrice;
    if (m.setupFee !== undefined)
        o['setupFee'] = m.setupFee;
    return o;
}
export function priceFromJson(o) {
    var _a, _b, _c, _d;
    return {
        price: (_a = o['price']) !== null && _a !== void 0 ? _a : 0,
        frequency: (_b = o['frequency']) !== null && _b !== void 0 ? _b : 'MONTHLY',
        isStartingPrice: (_c = o['isStartingPrice']) !== null && _c !== void 0 ? _c : false,
        setupFee: (_d = o['setupFee']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function pricingToJson(m) {
    const o = {};
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.prices !== undefined) {
        o['prices'] = m.prices.map(e => priceToJson(e));
    }
    if (m.price !== undefined)
        o['price'] = priceToJson(m.price);
    return o;
}
export function pricingFromJson(o) {
    var _a, _b;
    return {
        currency: (_a = o['currency']) !== null && _a !== void 0 ? _a : 'USD',
        prices: ((_b = o['prices']) !== null && _b !== void 0 ? _b : []).map(e => priceFromJson(e)),
        price: o['price'] ? priceFromJson(o['price']) : undefined,
    };
}
export function lineItemToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.quantity !== undefined)
        o['quantity'] = m.quantity;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    if (m.price !== undefined)
        o['price'] = retailPriceToJson(m.price);
    if (m.defaultCustomPrice !== undefined)
        o['defaultCustomPrice'] = m.defaultCustomPrice;
    if (m.parent !== undefined) {
        if (m.parent.type === 'parentId') {
            o['parentId'] = m.parent.parentId;
        }
    }
    else {
        if (m.parentId !== undefined)
            o['parentId'] = m.parentId;
    }
    return o;
}
export function lineItemFromJson(o) {
    var _a, _b, _c, _d;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        quantity: (_b = o['quantity']) !== null && _b !== void 0 ? _b : 0,
        editionId: (_c = o['editionId']) !== null && _c !== void 0 ? _c : '',
        price: o['price'] ? retailPriceFromJson(o['price']) : undefined,
        defaultCustomPrice: (_d = o['defaultCustomPrice']) !== null && _d !== void 0 ? _d : 0,
        parent: (() => {
            if (o['parentId'] !== undefined)
                return { type: 'parentId', parentId: o['parentId'] };
            return undefined;
        })(),
        parentId: o['parentId'] !== undefined ? o['parentId'] : undefined,
    };
}
export function lineItemsToJson(m) {
    const o = {};
    if (m.lineItems !== undefined) {
        o['lineItems'] = m.lineItems.map(e => lineItemToJson(e));
    }
    return o;
}
export function lineItemsFromJson(o) {
    var _a;
    return {
        lineItems: ((_a = o['lineItems']) !== null && _a !== void 0 ? _a : []).map(e => lineItemFromJson(e)),
    };
}
export function externalUrlActionToJson(m) {
    const o = {};
    if (m.url !== undefined)
        o['url'] = m.url;
    return o;
}
export function externalUrlActionFromJson(o) {
    var _a;
    return {
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
    };
}
export function defaultActionToJson(m) {
    const o = {};
    return o;
}
export function defaultActionFromJson(o) {
    return {};
}
export function contactFormActionToJson(m) {
    const o = {};
    return o;
}
export function contactFormActionFromJson(o) {
    return {};
}
export function orderFormActionToJson(m) {
    const o = {};
    return o;
}
export function orderFormActionFromJson(o) {
    return {};
}
export function marketActionToJson(m) {
    const o = {};
    if (m.marketAction !== undefined) {
        if (m.marketAction.type === 'default') {
            o['default'] = defaultActionToJson(m.marketAction.default);
        }
        if (m.marketAction.type === 'externalUrl') {
            o['externalUrl'] = externalUrlActionToJson(m.marketAction.externalUrl);
        }
        if (m.marketAction.type === 'contactForm') {
            o['contactForm'] = contactFormActionToJson(m.marketAction.contactForm);
        }
        if (m.marketAction.type === 'orderForm') {
            o['orderForm'] = orderFormActionToJson(m.marketAction.orderForm);
        }
    }
    else {
        if (m.default !== undefined)
            o['default'] = defaultActionToJson(m.default);
        if (m.externalUrl !== undefined)
            o['externalUrl'] = externalUrlActionToJson(m.externalUrl);
        if (m.contactForm !== undefined)
            o['contactForm'] = contactFormActionToJson(m.contactForm);
        if (m.orderForm !== undefined)
            o['orderForm'] = orderFormActionToJson(m.orderForm);
    }
    return o;
}
export function marketActionFromJson(o) {
    return {
        marketAction: (() => {
            if (o['default'] !== undefined)
                return { type: 'default', default: o['default'] ? defaultActionFromJson(o['default']) : undefined };
            if (o['externalUrl'] !== undefined)
                return { type: 'externalUrl', externalUrl: o['externalUrl'] ? externalUrlActionFromJson(o['externalUrl']) : undefined };
            if (o['contactForm'] !== undefined)
                return { type: 'contactForm', contactForm: o['contactForm'] ? contactFormActionFromJson(o['contactForm']) : undefined };
            if (o['orderForm'] !== undefined)
                return { type: 'orderForm', orderForm: o['orderForm'] ? orderFormActionFromJson(o['orderForm']) : undefined };
            return undefined;
        })(),
        default: o['default'] !== undefined ? o['default'] ? defaultActionFromJson(o['default']) : undefined : undefined,
        externalUrl: o['externalUrl'] !== undefined ? o['externalUrl'] ? externalUrlActionFromJson(o['externalUrl']) : undefined : undefined,
        contactForm: o['contactForm'] !== undefined ? o['contactForm'] ? contactFormActionFromJson(o['contactForm']) : undefined : undefined,
        orderForm: o['orderForm'] !== undefined ? o['orderForm'] ? orderFormActionFromJson(o['orderForm']) : undefined : undefined,
    };
}
export function packageToJson(m) {
    const o = {};
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.archived !== undefined)
        o['archived'] = m.archived.toISOString();
    if (m.updatedBy !== undefined)
        o['updatedBy'] = m.updatedBy;
    if (m.packageId !== undefined)
        o['packageId'] = m.packageId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.icon !== undefined)
        o['icon'] = m.icon;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.headerImageUrl !== undefined)
        o['headerImageUrl'] = m.headerImageUrl;
    if (m.tagline !== undefined)
        o['tagline'] = m.tagline;
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.products !== undefined) {
        o['products'] = m.products.map(e => e);
    }
    if (m.hideProductDetails !== undefined)
        o['hideProductDetails'] = m.hideProductDetails;
    if (m.hideProductIconsAndNames !== undefined)
        o['hideProductIconsAndNames'] = m.hideProductIconsAndNames;
    if (m.pricing !== undefined)
        o['pricing'] = pricingToJson(m.pricing);
    if (m.normalizedAnnualPrice !== undefined)
        o['normalizedAnnualPrice'] = m.normalizedAnnualPrice;
    if (m.addonKeys !== undefined) {
        o['addonKeys'] = m.addonKeys.map(e => addonKeyToJson(e));
    }
    if (m.productOrder !== undefined) {
        o['productOrder'] = m.productOrder.map(e => e);
    }
    if (m.lineItems !== undefined)
        o['lineItems'] = lineItemsToJson(m.lineItems);
    if (m.marketAction !== undefined)
        o['marketAction'] = marketActionToJson(m.marketAction);
    if (m.usesBillingPricing !== undefined)
        o['usesBillingPricing'] = m.usesBillingPricing;
    if (m.pricingDisplayOption !== undefined)
        o['pricingDisplayOption'] = m.pricingDisplayOption;
    if (m.lineItemDisplayOption !== undefined)
        o['lineItemDisplayOption'] = m.lineItemDisplayOption;
    return o;
}
export function packageFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    return {
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        archived: o['archived'] ? new Date(o['archived']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updatedBy: (_a = o['updatedBy']) !== null && _a !== void 0 ? _a : '',
        packageId: (_b = o['packageId']) !== null && _b !== void 0 ? _b : '',
        partnerId: (_c = o['partnerId']) !== null && _c !== void 0 ? _c : '',
        marketId: (_d = o['marketId']) !== null && _d !== void 0 ? _d : '',
        name: (_e = o['name']) !== null && _e !== void 0 ? _e : '',
        icon: (_f = o['icon']) !== null && _f !== void 0 ? _f : '',
        status: (_g = o['status']) !== null && _g !== void 0 ? _g : 'DRAFT',
        headerImageUrl: (_h = o['headerImageUrl']) !== null && _h !== void 0 ? _h : '',
        tagline: (_j = o['tagline']) !== null && _j !== void 0 ? _j : '',
        content: (_k = o['content']) !== null && _k !== void 0 ? _k : '',
        products: ((_l = o['products']) !== null && _l !== void 0 ? _l : []).map(e => e),
        hideProductDetails: (_m = o['hideProductDetails']) !== null && _m !== void 0 ? _m : false,
        hideProductIconsAndNames: (_o = o['hideProductIconsAndNames']) !== null && _o !== void 0 ? _o : false,
        pricing: o['pricing'] ? pricingFromJson(o['pricing']) : undefined,
        normalizedAnnualPrice: (_p = o['normalizedAnnualPrice']) !== null && _p !== void 0 ? _p : 0,
        addonKeys: ((_q = o['addonKeys']) !== null && _q !== void 0 ? _q : []).map(e => addonKeyFromJson(e)),
        productOrder: ((_r = o['productOrder']) !== null && _r !== void 0 ? _r : []).map(e => e),
        lineItems: o['lineItems'] ? lineItemsFromJson(o['lineItems']) : undefined,
        marketAction: o['marketAction'] ? marketActionFromJson(o['marketAction']) : undefined,
        usesBillingPricing: (_s = o['usesBillingPricing']) !== null && _s !== void 0 ? _s : false,
        pricingDisplayOption: (_t = o['pricingDisplayOption']) !== null && _t !== void 0 ? _t : 'PRICING_DISPLAY_OPTION_NOT_SPECIFIED',
        lineItemDisplayOption: (_u = o['lineItemDisplayOption']) !== null && _u !== void 0 ? _u : 'LINE_ITEM_DISPLAY_OPTION_UNSET',
    };
}
export function pagedRequestOptionsToJson(m) {
    const o = {};
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function pagedRequestOptionsFromJson(o) {
    var _a, _b;
    return {
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function pagedResponseMetadataToJson(m) {
    const o = {};
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.totalResults !== undefined)
        o['totalResults'] = m.totalResults;
    return o;
}
export function pagedResponseMetadataFromJson(o) {
    var _a, _b, _c;
    return {
        nextCursor: (_a = o['nextCursor']) !== null && _a !== void 0 ? _a : '',
        hasMore: (_b = o['hasMore']) !== null && _b !== void 0 ? _b : false,
        totalResults: (_c = o['totalResults']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function listPackagesRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.lmiCategory !== undefined)
        o['lmiCategory'] = m.lmiCategory;
    if (m.statuses !== undefined) {
        o['statuses'] = m.statuses.map(e => e);
    }
    if (m.sort !== undefined)
        o['sort'] = m.sort;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.includeTotalResults !== undefined)
        o['includeTotalResults'] = m.includeTotalResults;
    if (m.filterTerm !== undefined)
        o['filterTerm'] = m.filterTerm;
    return o;
}
export function listPackagesRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        lmiCategory: (_c = o['lmiCategory']) !== null && _c !== void 0 ? _c : 'NOT_SET',
        statuses: ((_d = o['statuses']) !== null && _d !== void 0 ? _d : []).map(e => e),
        sort: (_e = o['sort']) !== null && _e !== void 0 ? _e : false,
        pageSize: (_f = o['pageSize']) !== null && _f !== void 0 ? _f : 0,
        cursor: (_g = o['cursor']) !== null && _g !== void 0 ? _g : '',
        includeTotalResults: (_h = o['includeTotalResults']) !== null && _h !== void 0 ? _h : false,
        filterTerm: (_j = o['filterTerm']) !== null && _j !== void 0 ? _j : '',
    };
}
export function listPackagesResponseToJson(m) {
    const o = {};
    if (m.packages !== undefined) {
        o['packages'] = m.packages.map(e => packageToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.totalResults !== undefined)
        o['totalResults'] = m.totalResults;
    return o;
}
export function listPackagesResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        packages: ((_a = o['packages']) !== null && _a !== void 0 ? _a : []).map(e => packageFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
        totalResults: (_d = o['totalResults']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function listProductFilterToJson(m) {
    const o = {};
    if (m.approved !== undefined)
        o['approved'] = m.approved;
    if (m.state !== undefined)
        o['state'] = m.state;
    return o;
}
export function listProductFilterFromJson(o) {
    var _a, _b;
    return {
        approved: (_a = o['approved']) !== null && _a !== void 0 ? _a : false,
        state: (_b = o['state']) !== null && _b !== void 0 ? _b : 'STATE_FILTER_OPTIONS_PUBLISHED',
    };
}
export function listProductsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.filters !== undefined)
        o['filters'] = listProductFilterToJson(m.filters);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.whitelabelOverrideKey !== undefined)
        o['whitelabelOverrideKey'] = m.whitelabelOverrideKey;
    return o;
}
export function listProductsRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
        cursor: (_c = o['cursor']) !== null && _c !== void 0 ? _c : '',
        marketId: (_d = o['marketId']) !== null && _d !== void 0 ? _d : '',
        filters: o['filters'] ? listProductFilterFromJson(o['filters']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        whitelabelOverrideKey: (_e = o['whitelabelOverrideKey']) !== null && _e !== void 0 ? _e : '',
    };
}
export function listProductsResponseToJson(m) {
    const o = {};
    if (m.products !== undefined) {
        o['products'] = m.products.map(e => productToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listProductsResponseFromJson(o) {
    var _a, _b, _c;
    return {
        products: ((_a = o['products']) !== null && _a !== void 0 ? _a : []).map(e => productFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function listAddonsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.appIds !== undefined) {
        o['appIds'] = m.appIds.map(e => e);
    }
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.whitelabelOverrideKey !== undefined)
        o['whitelabelOverrideKey'] = m.whitelabelOverrideKey;
    return o;
}
export function listAddonsRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        appIds: ((_b = o['appIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        pageSize: (_c = o['pageSize']) !== null && _c !== void 0 ? _c : 0,
        cursor: (_d = o['cursor']) !== null && _d !== void 0 ? _d : '',
        whitelabelOverrideKey: (_e = o['whitelabelOverrideKey']) !== null && _e !== void 0 ? _e : '',
    };
}
export function listAddonsResponseToJson(m) {
    const o = {};
    if (m.addons !== undefined) {
        o['addons'] = m.addons.map(e => addonToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listAddonsResponseFromJson(o) {
    var _a, _b, _c;
    return {
        addons: ((_a = o['addons']) !== null && _a !== void 0 ? _a : []).map(e => addonFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function getMultiProductsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.productIds !== undefined) {
        o['productIds'] = m.productIds.map(e => e);
    }
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.whitelabelOverrideKey !== undefined)
        o['whitelabelOverrideKey'] = m.whitelabelOverrideKey;
    return o;
}
export function getMultiProductsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        productIds: ((_b = o['productIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        marketId: (_c = o['marketId']) !== null && _c !== void 0 ? _c : '',
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        whitelabelOverrideKey: (_d = o['whitelabelOverrideKey']) !== null && _d !== void 0 ? _d : '',
    };
}
export function getMultiProductsResponseToJson(m) {
    const o = {};
    if (m.products !== undefined) {
        o['products'] = m.products.map(e => getMultiProductsResponseProductContainerToJson(e));
    }
    return o;
}
export function getMultiProductsResponseFromJson(o) {
    var _a;
    return {
        products: ((_a = o['products']) !== null && _a !== void 0 ? _a : []).map(e => getMultiProductsResponseProductContainerFromJson(e)),
    };
}
export function getMultiProductsResponseProductContainerToJson(m) {
    const o = {};
    if (m.product !== undefined)
        o['product'] = productToJson(m.product);
    return o;
}
export function getMultiProductsResponseProductContainerFromJson(o) {
    return {
        product: o['product'] ? productFromJson(o['product']) : undefined,
    };
}
export function getMultiAddonsRequestToJson(m) {
    const o = {};
    if (m.addonKeys !== undefined) {
        o['addonKeys'] = m.addonKeys.map(e => addonKeyToJson(e));
    }
    if (m.whitelabelOverrideKey !== undefined)
        o['whitelabelOverrideKey'] = m.whitelabelOverrideKey;
    return o;
}
export function getMultiAddonsRequestFromJson(o) {
    var _a, _b;
    return {
        addonKeys: ((_a = o['addonKeys']) !== null && _a !== void 0 ? _a : []).map(e => addonKeyFromJson(e)),
        whitelabelOverrideKey: (_b = o['whitelabelOverrideKey']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getMultiAddonsResponseToJson(m) {
    const o = {};
    if (m.addons !== undefined) {
        o['addons'] = m.addons.map(e => addonToJson(e));
    }
    return o;
}
export function getMultiAddonsResponseFromJson(o) {
    var _a;
    return {
        addons: ((_a = o['addons']) !== null && _a !== void 0 ? _a : []).map(e => addonFromJson(e)),
    };
}
export function getMultiPackageRequestToJson(m) {
    const o = {};
    if (m.packageIds !== undefined) {
        o['packageIds'] = m.packageIds.map(e => e);
    }
    return o;
}
export function getMultiPackageRequestFromJson(o) {
    var _a;
    return {
        packageIds: ((_a = o['packageIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function deletePackageRequestToJson(m) {
    const o = {};
    if (m.packageId !== undefined)
        o['packageId'] = m.packageId;
    return o;
}
export function deletePackageRequestFromJson(o) {
    var _a;
    return {
        packageId: (_a = o['packageId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function hideArchivedPackageRequestToJson(m) {
    const o = {};
    if (m.packageId !== undefined)
        o['packageId'] = m.packageId;
    return o;
}
export function hideArchivedPackageRequestFromJson(o) {
    var _a;
    return {
        packageId: (_a = o['packageId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updatePackageOperationToJson(m) {
    const o = {};
    if (m.operation !== undefined) {
        if (m.operation.type === 'name') {
            o['name'] = m.operation.name;
        }
        if (m.operation.type === 'tagline') {
            o['tagline'] = m.operation.tagline;
        }
        if (m.operation.type === 'iconUrl') {
            o['iconUrl'] = m.operation.iconUrl;
        }
        if (m.operation.type === 'headerImageUrl') {
            o['headerImageUrl'] = m.operation.headerImageUrl;
        }
        if (m.operation.type === 'content') {
            o['content'] = m.operation.content;
        }
        if (m.operation.type === 'pricing') {
            o['pricing'] = pricingToJson(m.operation.pricing);
        }
        if (m.operation.type === 'hideProductDetails') {
            o['hideProductDetails'] = m.operation.hideProductDetails;
        }
        if (m.operation.type === 'hideProductIconsAndNames') {
            o['hideProductIconsAndNames'] = m.operation.hideProductIconsAndNames;
        }
        if (m.operation.type === 'lineItems') {
            o['lineItems'] = lineItemsToJson(m.operation.lineItems);
        }
        if (m.operation.type === 'status') {
            o['status'] = m.operation.status;
        }
        if (m.operation.type === 'marketAction') {
            o['marketAction'] = marketActionToJson(m.operation.marketAction);
        }
        if (m.operation.type === 'usesBillingPricing') {
            o['usesBillingPricing'] = m.operation.usesBillingPricing;
        }
        if (m.operation.type === 'pricingDisplayOption') {
            o['pricingDisplayOption'] = m.operation.pricingDisplayOption;
        }
        if (m.operation.type === 'iconUrlV2') {
            o['iconUrlV2'] = m.operation.iconUrlV2;
        }
        if (m.operation.type === 'headerImageUrlV2') {
            o['headerImageUrlV2'] = m.operation.headerImageUrlV2;
        }
        if (m.operation.type === 'lineItemDisplayOption') {
            o['lineItemDisplayOption'] = m.operation.lineItemDisplayOption;
        }
    }
    else {
        if (m.name !== undefined)
            o['name'] = m.name;
        if (m.tagline !== undefined)
            o['tagline'] = m.tagline;
        if (m.iconUrl !== undefined)
            o['iconUrl'] = m.iconUrl;
        if (m.headerImageUrl !== undefined)
            o['headerImageUrl'] = m.headerImageUrl;
        if (m.content !== undefined)
            o['content'] = m.content;
        if (m.pricing !== undefined)
            o['pricing'] = pricingToJson(m.pricing);
        if (m.hideProductDetails !== undefined)
            o['hideProductDetails'] = m.hideProductDetails;
        if (m.hideProductIconsAndNames !== undefined)
            o['hideProductIconsAndNames'] = m.hideProductIconsAndNames;
        if (m.lineItems !== undefined)
            o['lineItems'] = lineItemsToJson(m.lineItems);
        if (m.status !== undefined)
            o['status'] = m.status;
        if (m.marketAction !== undefined)
            o['marketAction'] = marketActionToJson(m.marketAction);
        if (m.usesBillingPricing !== undefined)
            o['usesBillingPricing'] = m.usesBillingPricing;
        if (m.pricingDisplayOption !== undefined)
            o['pricingDisplayOption'] = m.pricingDisplayOption;
        if (m.iconUrlV2 !== undefined)
            o['iconUrlV2'] = m.iconUrlV2;
        if (m.headerImageUrlV2 !== undefined)
            o['headerImageUrlV2'] = m.headerImageUrlV2;
        if (m.lineItemDisplayOption !== undefined)
            o['lineItemDisplayOption'] = m.lineItemDisplayOption;
    }
    return o;
}
export function updatePackageOperationFromJson(o) {
    return {
        operation: (() => {
            if (o['name'] !== undefined)
                return { type: 'name', name: o['name'] };
            if (o['tagline'] !== undefined)
                return { type: 'tagline', tagline: o['tagline'] };
            if (o['iconUrl'] !== undefined)
                return { type: 'iconUrl', iconUrl: o['iconUrl'] };
            if (o['headerImageUrl'] !== undefined)
                return { type: 'headerImageUrl', headerImageUrl: o['headerImageUrl'] };
            if (o['content'] !== undefined)
                return { type: 'content', content: o['content'] };
            if (o['pricing'] !== undefined)
                return { type: 'pricing', pricing: o['pricing'] ? pricingFromJson(o['pricing']) : undefined };
            if (o['hideProductDetails'] !== undefined)
                return { type: 'hideProductDetails', hideProductDetails: o['hideProductDetails'] };
            if (o['hideProductIconsAndNames'] !== undefined)
                return { type: 'hideProductIconsAndNames', hideProductIconsAndNames: o['hideProductIconsAndNames'] };
            if (o['lineItems'] !== undefined)
                return { type: 'lineItems', lineItems: o['lineItems'] ? lineItemsFromJson(o['lineItems']) : undefined };
            if (o['status'] !== undefined)
                return { type: 'status', status: o['status'] };
            if (o['marketAction'] !== undefined)
                return { type: 'marketAction', marketAction: o['marketAction'] ? marketActionFromJson(o['marketAction']) : undefined };
            if (o['usesBillingPricing'] !== undefined)
                return { type: 'usesBillingPricing', usesBillingPricing: o['usesBillingPricing'] };
            if (o['pricingDisplayOption'] !== undefined)
                return { type: 'pricingDisplayOption', pricingDisplayOption: o['pricingDisplayOption'] };
            if (o['iconUrlV2'] !== undefined)
                return { type: 'iconUrlV2', iconUrlV2: o['iconUrlV2'] };
            if (o['headerImageUrlV2'] !== undefined)
                return { type: 'headerImageUrlV2', headerImageUrlV2: o['headerImageUrlV2'] };
            if (o['lineItemDisplayOption'] !== undefined)
                return { type: 'lineItemDisplayOption', lineItemDisplayOption: o['lineItemDisplayOption'] };
            return undefined;
        })(),
        name: o['name'] !== undefined ? o['name'] : undefined,
        tagline: o['tagline'] !== undefined ? o['tagline'] : undefined,
        iconUrl: o['iconUrl'] !== undefined ? o['iconUrl'] : undefined,
        headerImageUrl: o['headerImageUrl'] !== undefined ? o['headerImageUrl'] : undefined,
        content: o['content'] !== undefined ? o['content'] : undefined,
        pricing: o['pricing'] !== undefined ? o['pricing'] ? pricingFromJson(o['pricing']) : undefined : undefined,
        hideProductDetails: o['hideProductDetails'] !== undefined ? o['hideProductDetails'] : undefined,
        hideProductIconsAndNames: o['hideProductIconsAndNames'] !== undefined ? o['hideProductIconsAndNames'] : undefined,
        lineItems: o['lineItems'] !== undefined ? o['lineItems'] ? lineItemsFromJson(o['lineItems']) : undefined : undefined,
        status: o['status'] !== undefined ? o['status'] : undefined,
        marketAction: o['marketAction'] !== undefined ? o['marketAction'] ? marketActionFromJson(o['marketAction']) : undefined : undefined,
        usesBillingPricing: o['usesBillingPricing'] !== undefined ? o['usesBillingPricing'] : undefined,
        pricingDisplayOption: o['pricingDisplayOption'] !== undefined ? o['pricingDisplayOption'] : undefined,
        iconUrlV2: o['iconUrlV2'] !== undefined ? o['iconUrlV2'] : undefined,
        headerImageUrlV2: o['headerImageUrlV2'] !== undefined ? o['headerImageUrlV2'] : undefined,
        lineItemDisplayOption: o['lineItemDisplayOption'] !== undefined ? o['lineItemDisplayOption'] : undefined,
    };
}
export function updatePackageRequestToJson(m) {
    const o = {};
    if (m.packageId !== undefined)
        o['packageId'] = m.packageId;
    if (m.updatePackageOperations !== undefined) {
        o['updatePackageOperations'] = m.updatePackageOperations.map(e => updatePackageOperationToJson(e));
    }
    return o;
}
export function updatePackageRequestFromJson(o) {
    var _a, _b;
    return {
        packageId: (_a = o['packageId']) !== null && _a !== void 0 ? _a : '',
        updatePackageOperations: ((_b = o['updatePackageOperations']) !== null && _b !== void 0 ? _b : []).map(e => updatePackageOperationFromJson(e)),
    };
}
export function updatePackageResponseToJson(m) {
    const o = {};
    if (m.package !== undefined)
        o['package'] = packageToJson(m.package);
    return o;
}
export function updatePackageResponseFromJson(o) {
    return {
        package: o['package'] ? packageFromJson(o['package']) : undefined,
    };
}
export function createPackageRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.tagline !== undefined)
        o['tagline'] = m.tagline;
    if (m.iconUrl !== undefined)
        o['iconUrl'] = m.iconUrl;
    if (m.headerImageUrl !== undefined)
        o['headerImageUrl'] = m.headerImageUrl;
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.pricing !== undefined)
        o['pricing'] = pricingToJson(m.pricing);
    if (m.hideProductDetails !== undefined)
        o['hideProductDetails'] = m.hideProductDetails;
    if (m.hideProductIconsAndNames !== undefined)
        o['hideProductIconsAndNames'] = m.hideProductIconsAndNames;
    if (m.publishImmediately !== undefined)
        o['publishImmediately'] = m.publishImmediately;
    if (m.lineItems !== undefined)
        o['lineItems'] = lineItemsToJson(m.lineItems);
    if (m.marketAction !== undefined)
        o['marketAction'] = marketActionToJson(m.marketAction);
    if (m.usesBillingPricing !== undefined)
        o['usesBillingPricing'] = m.usesBillingPricing;
    if (m.pricingDisplayOption !== undefined)
        o['pricingDisplayOption'] = m.pricingDisplayOption;
    if (m.lineItemDisplayOption !== undefined)
        o['lineItemDisplayOption'] = m.lineItemDisplayOption;
    return o;
}
export function createPackageRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
        tagline: (_d = o['tagline']) !== null && _d !== void 0 ? _d : '',
        iconUrl: (_e = o['iconUrl']) !== null && _e !== void 0 ? _e : '',
        headerImageUrl: (_f = o['headerImageUrl']) !== null && _f !== void 0 ? _f : '',
        content: (_g = o['content']) !== null && _g !== void 0 ? _g : '',
        pricing: o['pricing'] ? pricingFromJson(o['pricing']) : undefined,
        hideProductDetails: (_h = o['hideProductDetails']) !== null && _h !== void 0 ? _h : false,
        hideProductIconsAndNames: (_j = o['hideProductIconsAndNames']) !== null && _j !== void 0 ? _j : false,
        publishImmediately: (_k = o['publishImmediately']) !== null && _k !== void 0 ? _k : false,
        lineItems: o['lineItems'] ? lineItemsFromJson(o['lineItems']) : undefined,
        marketAction: o['marketAction'] ? marketActionFromJson(o['marketAction']) : undefined,
        usesBillingPricing: (_l = o['usesBillingPricing']) !== null && _l !== void 0 ? _l : false,
        pricingDisplayOption: (_m = o['pricingDisplayOption']) !== null && _m !== void 0 ? _m : 'PRICING_DISPLAY_OPTION_NOT_SPECIFIED',
        lineItemDisplayOption: (_o = o['lineItemDisplayOption']) !== null && _o !== void 0 ? _o : 'LINE_ITEM_DISPLAY_OPTION_UNSET',
    };
}
export function createPackageResponseToJson(m) {
    const o = {};
    if (m.package !== undefined)
        o['package'] = packageToJson(m.package);
    return o;
}
export function createPackageResponseFromJson(o) {
    return {
        package: o['package'] ? packageFromJson(o['package']) : undefined,
    };
}
export function listAppDistributionStatusRequestToJson(m) {
    const o = {};
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    return o;
}
export function listAppDistributionStatusRequestFromJson(o) {
    var _a, _b;
    return {
        pageSize: (_a = o['pageSize']) !== null && _a !== void 0 ? _a : 0,
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listAppDistributionStatusResponseToJson(m) {
    const o = {};
    if (m.appDistributionStatuses !== undefined) {
        o['appDistributionStatuses'] = m.appDistributionStatuses.map(e => listAppDistributionStatusResponseAppDistributionStatusToJson(e));
    }
    return o;
}
export function listAppDistributionStatusResponseFromJson(o) {
    var _a;
    return {
        appDistributionStatuses: ((_a = o['appDistributionStatuses']) !== null && _a !== void 0 ? _a : []).map(e => listAppDistributionStatusResponseAppDistributionStatusFromJson(e)),
    };
}
export function listAppDistributionStatusResponseAppDistributionStatusToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.whitelist !== undefined) {
        o['whitelist'] = m.whitelist.map(e => e);
    }
    if (m.blacklist !== undefined) {
        o['blacklist'] = m.blacklist.map(e => e);
    }
    if (m.distributable !== undefined)
        o['distributable'] = m.distributable;
    return o;
}
export function listAppDistributionStatusResponseAppDistributionStatusFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        whitelist: ((_c = o['whitelist']) !== null && _c !== void 0 ? _c : []).map(e => e),
        blacklist: ((_d = o['blacklist']) !== null && _d !== void 0 ? _d : []).map(e => e),
        distributable: (_e = o['distributable']) !== null && _e !== void 0 ? _e : false,
    };
}
export function getAppPermissionsRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    return o;
}
export function getAppPermissionsRequestFromJson(o) {
    var _a;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getAppPermissionsResponseToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.whitelist !== undefined) {
        o['whitelist'] = m.whitelist.map(e => e);
    }
    if (m.blacklist !== undefined) {
        o['blacklist'] = m.blacklist.map(e => e);
    }
    if (m.distributed !== undefined)
        o['distributed'] = m.distributed;
    return o;
}
export function getAppPermissionsResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        whitelist: ((_b = o['whitelist']) !== null && _b !== void 0 ? _b : []).map(e => e),
        blacklist: ((_c = o['blacklist']) !== null && _c !== void 0 ? _c : []).map(e => e),
        distributed: (_d = o['distributed']) !== null && _d !== void 0 ? _d : false,
    };
}
export function removePartnerFromPermissionsListRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.permissionsList !== undefined)
        o['permissionsList'] = m.permissionsList;
    return o;
}
export function removePartnerFromPermissionsListRequestFromJson(o) {
    var _a, _b, _c;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        permissionsList: (_c = o['permissionsList']) !== null && _c !== void 0 ? _c : 'PERMISSIONS_LIST_NOT_SPECIFIED',
    };
}
export function upsertAppPermissionsRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.whitelist !== undefined) {
        o['whitelist'] = m.whitelist.map(e => e);
    }
    if (m.blacklist !== undefined) {
        o['blacklist'] = m.blacklist.map(e => e);
    }
    if (m.distributed !== undefined)
        o['distributed'] = m.distributed;
    return o;
}
export function upsertAppPermissionsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        whitelist: ((_b = o['whitelist']) !== null && _b !== void 0 ? _b : []).map(e => e),
        blacklist: ((_c = o['blacklist']) !== null && _c !== void 0 ? _c : []).map(e => e),
        distributed: (_d = o['distributed']) !== null && _d !== void 0 ? _d : false,
    };
}
export function upsertAppPermissionsResponseToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.whitelist !== undefined) {
        o['whitelist'] = m.whitelist.map(e => e);
    }
    if (m.blacklist !== undefined) {
        o['blacklist'] = m.blacklist.map(e => e);
    }
    if (m.distributed !== undefined)
        o['distributed'] = m.distributed;
    return o;
}
export function upsertAppPermissionsResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        whitelist: ((_b = o['whitelist']) !== null && _b !== void 0 ? _b : []).map(e => e),
        blacklist: ((_c = o['blacklist']) !== null && _c !== void 0 ? _c : []).map(e => e),
        distributed: (_d = o['distributed']) !== null && _d !== void 0 ? _d : false,
    };
}
export function tagToJson(m) {
    const o = {};
    if (m.kind !== undefined)
        o['kind'] = m.kind;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function tagFromJson(o) {
    var _a, _b;
    return {
        kind: (_a = o['kind']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function addonOptionsToJson(m) {
    const o = {};
    if (m.groupAddonsWithParent !== undefined)
        o['groupAddonsWithParent'] = m.groupAddonsWithParent;
    if (m.displayNonDiscoverableAddons !== undefined)
        o['displayNonDiscoverableAddons'] = m.displayNonDiscoverableAddons;
    return o;
}
export function addonOptionsFromJson(o) {
    var _a, _b;
    return {
        groupAddonsWithParent: (_a = o['groupAddonsWithParent']) !== null && _a !== void 0 ? _a : false,
        displayNonDiscoverableAddons: (_b = o['displayNonDiscoverableAddons']) !== null && _b !== void 0 ? _b : false,
    };
}
export function listDiscoverableAppSuggestionsRequestToJson(m) {
    const o = {};
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function listDiscoverableAppSuggestionsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        pageSize: (_c = o['pageSize']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function listDiscoverableAppSuggestionsResponseToJson(m) {
    const o = {};
    if (m.suggestions !== undefined) {
        o['suggestions'] = m.suggestions.map(e => listDiscoverableAppSuggestionsResponseSuggestionToJson(e));
    }
    return o;
}
export function listDiscoverableAppSuggestionsResponseFromJson(o) {
    var _a;
    return {
        suggestions: ((_a = o['suggestions']) !== null && _a !== void 0 ? _a : []).map(e => listDiscoverableAppSuggestionsResponseSuggestionFromJson(e)),
    };
}
export function listDiscoverableAppSuggestionsResponseSuggestionToJson(m) {
    const o = {};
    if (m.appName !== undefined)
        o['appName'] = m.appName;
    return o;
}
export function listDiscoverableAppSuggestionsResponseSuggestionFromJson(o) {
    var _a;
    return {
        appName: (_a = o['appName']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listDiscoverableAppsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.whitelabelOverrideKey !== undefined)
        o['whitelabelOverrideKey'] = m.whitelabelOverrideKey;
    if (m.tagFilters !== undefined) {
        o['tagFilters'] = m.tagFilters.map(e => tagToJson(e));
    }
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.sortOrder !== undefined)
        o['sortOrder'] = m.sortOrder;
    if (m.addonOptions !== undefined)
        o['addonOptions'] = addonOptionsToJson(m.addonOptions);
    return o;
}
export function listDiscoverableAppsRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
        cursor: (_c = o['cursor']) !== null && _c !== void 0 ? _c : '',
        marketId: (_d = o['marketId']) !== null && _d !== void 0 ? _d : '',
        whitelabelOverrideKey: (_e = o['whitelabelOverrideKey']) !== null && _e !== void 0 ? _e : '',
        tagFilters: ((_f = o['tagFilters']) !== null && _f !== void 0 ? _f : []).map(e => tagFromJson(e)),
        searchTerm: (_g = o['searchTerm']) !== null && _g !== void 0 ? _g : '',
        sortOrder: (_h = o['sortOrder']) !== null && _h !== void 0 ? _h : 'SORT_ORDER_NOT_SPECIFIED',
        addonOptions: o['addonOptions'] ? addonOptionsFromJson(o['addonOptions']) : undefined,
    };
}
export function costToJson(m) {
    const o = {};
    if (m.billingFrequency !== undefined)
        o['billingFrequency'] = m.billingFrequency;
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.price !== undefined)
        o['price'] = m.price;
    return o;
}
export function costFromJson(o) {
    var _a, _b, _c;
    return {
        billingFrequency: (_a = o['billingFrequency']) !== null && _a !== void 0 ? _a : '',
        currency: (_b = o['currency']) !== null && _b !== void 0 ? _b : '',
        price: (_c = o['price']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function kindValuesToJson(m) {
    const o = {};
    if (m.kind !== undefined)
        o['kind'] = m.kind;
    if (m.values !== undefined) {
        o['values'] = m.values.map(e => e);
    }
    return o;
}
export function kindValuesFromJson(o) {
    var _a, _b;
    return {
        kind: (_a = o['kind']) !== null && _a !== void 0 ? _a : '',
        values: ((_b = o['values']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function appDataToJson(m) {
    const o = {};
    if (m.scope !== undefined)
        o['scope'] = m.scope;
    if (m.kindValues !== undefined) {
        o['kindValues'] = m.kindValues.map(e => kindValuesToJson(e));
    }
    return o;
}
export function appDataFromJson(o) {
    var _a, _b;
    return {
        scope: (_a = o['scope']) !== null && _a !== void 0 ? _a : '',
        kindValues: ((_b = o['kindValues']) !== null && _b !== void 0 ? _b : []).map(e => kindValuesFromJson(e)),
    };
}
export function vendorRetailPriceToJson(m) {
    const o = {};
    if (m.billingFrequency !== undefined)
        o['billingFrequency'] = m.billingFrequency;
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.price !== undefined)
        o['price'] = m.price;
    if (m.editionPrice !== undefined)
        o['editionPrice'] = m.editionPrice;
    return o;
}
export function vendorRetailPriceFromJson(o) {
    var _a, _b, _c, _d;
    return {
        billingFrequency: (_a = o['billingFrequency']) !== null && _a !== void 0 ? _a : '',
        currency: (_b = o['currency']) !== null && _b !== void 0 ? _b : '',
        price: (_c = o['price']) !== null && _c !== void 0 ? _c : 0,
        editionPrice: (_d = o['editionPrice']) !== null && _d !== void 0 ? _d : false,
    };
}
export function discoverableAppParentToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.name !== undefined)
        o['name'] = m.name;
    return o;
}
export function discoverableAppParentFromJson(o) {
    var _a, _b;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
    };
}
export function discoverableAppSummaryToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.icon !== undefined)
        o['icon'] = m.icon;
    if (m.headerImage !== undefined)
        o['headerImage'] = m.headerImage;
    if (m.tagline !== undefined)
        o['tagline'] = m.tagline;
    if (m.price !== undefined)
        o['price'] = m.price;
    if (m.billingFrequency !== undefined)
        o['billingFrequency'] = m.billingFrequency;
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    if (m.lmiCategories !== undefined) {
        o['lmiCategories'] = m.lmiCategories.map(e => e);
    }
    if (m.billingId !== undefined)
        o['billingId'] = m.billingId;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.cost !== undefined)
        o['cost'] = costToJson(m.cost);
    if (m.appData !== undefined)
        o['appData'] = appDataToJson(m.appData);
    if (m.keySellingPoints !== undefined) {
        o['keySellingPoints'] = m.keySellingPoints.map(e => e);
    }
    if (m.suggestedRetailPrice !== undefined)
        o['suggestedRetailPrice'] = vendorRetailPriceToJson(m.suggestedRetailPrice);
    if (m.usesCustomPricing !== undefined)
        o['usesCustomPricing'] = m.usesCustomPricing;
    if (m.parent !== undefined)
        o['parent'] = discoverableAppParentToJson(m.parent);
    return o;
}
export function discoverableAppSummaryFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        icon: (_c = o['icon']) !== null && _c !== void 0 ? _c : '',
        headerImage: (_d = o['headerImage']) !== null && _d !== void 0 ? _d : '',
        tagline: (_e = o['tagline']) !== null && _e !== void 0 ? _e : '',
        price: (_f = o['price']) !== null && _f !== void 0 ? _f : 0,
        billingFrequency: (_g = o['billingFrequency']) !== null && _g !== void 0 ? _g : 'MONTHLY',
        currency: (_h = o['currency']) !== null && _h !== void 0 ? _h : 'USD',
        enabled: (_j = o['enabled']) !== null && _j !== void 0 ? _j : false,
        lmiCategories: ((_k = o['lmiCategories']) !== null && _k !== void 0 ? _k : []).map(e => e),
        billingId: (_l = o['billingId']) !== null && _l !== void 0 ? _l : '',
        type: (_m = o['type']) !== null && _m !== void 0 ? _m : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        cost: o['cost'] ? costFromJson(o['cost']) : undefined,
        appData: o['appData'] ? appDataFromJson(o['appData']) : undefined,
        keySellingPoints: ((_o = o['keySellingPoints']) !== null && _o !== void 0 ? _o : []).map(e => e),
        suggestedRetailPrice: o['suggestedRetailPrice'] ? vendorRetailPriceFromJson(o['suggestedRetailPrice']) : undefined,
        usesCustomPricing: (_p = o['usesCustomPricing']) !== null && _p !== void 0 ? _p : false,
        parent: o['parent'] ? discoverableAppParentFromJson(o['parent']) : undefined,
    };
}
export function listDiscoverableAppsResponseToJson(m) {
    const o = {};
    if (m.discoverableAppSummary !== undefined) {
        o['discoverableAppSummary'] = m.discoverableAppSummary.map(e => discoverableAppSummaryToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    if (m.totalResults !== undefined)
        o['totalResults'] = m.totalResults;
    return o;
}
export function listDiscoverableAppsResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        discoverableAppSummary: ((_a = o['discoverableAppSummary']) !== null && _a !== void 0 ? _a : []).map(e => discoverableAppSummaryFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
        totalResults: (_d = o['totalResults']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function listAvailableAppsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.whitelabelOverrideKey !== undefined)
        o['whitelabelOverrideKey'] = m.whitelabelOverrideKey;
    if (m.tagFilters !== undefined) {
        o['tagFilters'] = m.tagFilters.map(e => tagToJson(e));
    }
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function listAvailableAppsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        whitelabelOverrideKey: (_b = o['whitelabelOverrideKey']) !== null && _b !== void 0 ? _b : '',
        tagFilters: ((_c = o['tagFilters']) !== null && _c !== void 0 ? _c : []).map(e => tagFromJson(e)),
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        searchTerm: (_d = o['searchTerm']) !== null && _d !== void 0 ? _d : '',
    };
}
export function wholesalePriceToJson(m) {
    const o = {};
    if (m.billingFrequency !== undefined)
        o['billingFrequency'] = m.billingFrequency;
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.price !== undefined)
        o['price'] = m.price;
    return o;
}
export function wholesalePriceFromJson(o) {
    var _a, _b, _c;
    return {
        billingFrequency: (_a = o['billingFrequency']) !== null && _a !== void 0 ? _a : '',
        currency: (_b = o['currency']) !== null && _b !== void 0 ? _b : '',
        price: (_c = o['price']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function productPricingRuleToJson(m) {
    const o = {};
    if (m.price !== undefined)
        o['price'] = m.price;
    if (m.minUnits !== undefined)
        o['minUnits'] = m.minUnits;
    if (m.maxUnits !== undefined)
        o['maxUnits'] = m.maxUnits;
    return o;
}
export function productPricingRuleFromJson(o) {
    var _a, _b, _c;
    return {
        price: (_a = o['price']) !== null && _a !== void 0 ? _a : 0,
        minUnits: (_b = o['minUnits']) !== null && _b !== void 0 ? _b : 0,
        maxUnits: (_c = o['maxUnits']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function commitmentToJson(m) {
    const o = {};
    if (m.initial !== undefined)
        o['initial'] = m.initial;
    if (m.recurring !== undefined)
        o['recurring'] = m.recurring;
    return o;
}
export function commitmentFromJson(o) {
    var _a, _b;
    return {
        initial: (_a = o['initial']) !== null && _a !== void 0 ? _a : 0,
        recurring: (_b = o['recurring']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function billingWholesalePricingToJson(m) {
    const o = {};
    if (m.pricingType !== undefined)
        o['pricingType'] = m.pricingType;
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.frequency !== undefined)
        o['frequency'] = m.frequency;
    if (m.pricingRules !== undefined) {
        o['pricingRules'] = m.pricingRules.map(e => productPricingRuleToJson(e));
    }
    if (m.commitment !== undefined)
        o['commitment'] = commitmentToJson(m.commitment);
    if (m.isStartingPrice !== undefined)
        o['isStartingPrice'] = m.isStartingPrice;
    return o;
}
export function billingWholesalePricingFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        pricingType: (_a = o['pricingType']) !== null && _a !== void 0 ? _a : 'INVALID',
        currency: (_b = o['currency']) !== null && _b !== void 0 ? _b : '',
        frequency: (_c = o['frequency']) !== null && _c !== void 0 ? _c : '',
        pricingRules: ((_d = o['pricingRules']) !== null && _d !== void 0 ? _d : []).map(e => productPricingRuleFromJson(e)),
        commitment: o['commitment'] ? commitmentFromJson(o['commitment']) : undefined,
        isStartingPrice: (_e = o['isStartingPrice']) !== null && _e !== void 0 ? _e : false,
    };
}
export function productWholesalePriceToJson(m) {
    const o = {};
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.price !== undefined)
        o['price'] = m.price;
    if (m.frequency !== undefined)
        o['frequency'] = m.frequency;
    if (m.commitment !== undefined)
        o['commitment'] = commitmentToJson(m.commitment);
    if (m.isStartingAt !== undefined)
        o['isStartingAt'] = m.isStartingAt;
    if (m.shouldContactSales !== undefined)
        o['shouldContactSales'] = m.shouldContactSales;
    if (m.priceDisplaySku !== undefined)
        o['priceDisplaySku'] = m.priceDisplaySku;
    return o;
}
export function productWholesalePriceFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        currency: (_a = o['currency']) !== null && _a !== void 0 ? _a : '',
        price: (_b = o['price']) !== null && _b !== void 0 ? _b : 0,
        frequency: (_c = o['frequency']) !== null && _c !== void 0 ? _c : '',
        commitment: o['commitment'] ? commitmentFromJson(o['commitment']) : undefined,
        isStartingAt: (_d = o['isStartingAt']) !== null && _d !== void 0 ? _d : false,
        shouldContactSales: (_e = o['shouldContactSales']) !== null && _e !== void 0 ? _e : false,
        priceDisplaySku: (_f = o['priceDisplaySku']) !== null && _f !== void 0 ? _f : '',
    };
}
export function appSummaryToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.icon !== undefined)
        o['icon'] = m.icon;
    if (m.headerImage !== undefined)
        o['headerImage'] = m.headerImage;
    if (m.tagline !== undefined)
        o['tagline'] = m.tagline;
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    if (m.billingId !== undefined)
        o['billingId'] = m.billingId;
    if (m.vendorWholesale !== undefined)
        o['vendorWholesale'] = wholesalePriceToJson(m.vendorWholesale);
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.addons !== undefined) {
        o['addons'] = m.addons.map(e => appSummaryToJson(e));
    }
    if (m.vendorRetailPrice !== undefined)
        o['vendorRetailPrice'] = vendorRetailPriceToJson(m.vendorRetailPrice);
    if (m.wholesalePricingFromBilling !== undefined)
        o['wholesalePricingFromBilling'] = billingWholesalePricingToJson(m.wholesalePricingFromBilling);
    if (m.wholesalePrice !== undefined)
        o['wholesalePrice'] = productWholesalePriceToJson(m.wholesalePrice);
    if (m.setupFee !== undefined)
        o['setupFee'] = m.setupFee;
    return o;
}
export function appSummaryFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        icon: (_c = o['icon']) !== null && _c !== void 0 ? _c : '',
        headerImage: (_d = o['headerImage']) !== null && _d !== void 0 ? _d : '',
        tagline: (_e = o['tagline']) !== null && _e !== void 0 ? _e : '',
        enabled: (_f = o['enabled']) !== null && _f !== void 0 ? _f : false,
        billingId: (_g = o['billingId']) !== null && _g !== void 0 ? _g : '',
        vendorWholesale: o['vendorWholesale'] ? wholesalePriceFromJson(o['vendorWholesale']) : undefined,
        type: (_h = o['type']) !== null && _h !== void 0 ? _h : '',
        addons: ((_j = o['addons']) !== null && _j !== void 0 ? _j : []).map(e => appSummaryFromJson(e)),
        vendorRetailPrice: o['vendorRetailPrice'] ? vendorRetailPriceFromJson(o['vendorRetailPrice']) : undefined,
        wholesalePricingFromBilling: o['wholesalePricingFromBilling'] ? billingWholesalePricingFromJson(o['wholesalePricingFromBilling']) : undefined,
        wholesalePrice: o['wholesalePrice'] ? productWholesalePriceFromJson(o['wholesalePrice']) : undefined,
        setupFee: (_k = o['setupFee']) !== null && _k !== void 0 ? _k : 0,
    };
}
export function listAvailableAppsResponseToJson(m) {
    const o = {};
    if (m.availableAppsSummaries !== undefined) {
        o['availableAppsSummaries'] = m.availableAppsSummaries.map(e => appSummaryToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listAvailableAppsResponseFromJson(o) {
    var _a;
    return {
        availableAppsSummaries: ((_a = o['availableAppsSummaries']) !== null && _a !== void 0 ? _a : []).map(e => appSummaryFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function getMultiPackageResponseToJson(m) {
    const o = {};
    if (m.packageContainers !== undefined) {
        o['packageContainers'] = m.packageContainers.map(e => getMultiPackageResponsePackageContainerToJson(e));
    }
    return o;
}
export function getMultiPackageResponseFromJson(o) {
    var _a;
    return {
        packageContainers: ((_a = o['packageContainers']) !== null && _a !== void 0 ? _a : []).map(e => getMultiPackageResponsePackageContainerFromJson(e)),
    };
}
export function getMultiPackageResponsePackageContainerToJson(m) {
    const o = {};
    if (m.package !== undefined)
        o['package'] = packageToJson(m.package);
    return o;
}
export function getMultiPackageResponsePackageContainerFromJson(o) {
    return {
        package: o['package'] ? packageFromJson(o['package']) : undefined,
    };
}
export function activatableAppToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.headerImage !== undefined)
        o['headerImage'] = m.headerImage;
    if (m.tagline !== undefined)
        o['tagline'] = m.tagline;
    if (m.icon !== undefined)
        o['icon'] = m.icon;
    if (m.countryRestrictions !== undefined)
        o['countryRestrictions'] = permissionListsToJson(m.countryRestrictions);
    if (m.allowMultipleActivations !== undefined)
        o['allowMultipleActivations'] = m.allowMultipleActivations;
    if (m.childActivatableApps !== undefined) {
        o['childActivatableApps'] = m.childActivatableApps.map(e => activatableAppToJson(e));
    }
    return o;
}
export function activatableAppFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        headerImage: (_c = o['headerImage']) !== null && _c !== void 0 ? _c : '',
        tagline: (_d = o['tagline']) !== null && _d !== void 0 ? _d : '',
        icon: (_e = o['icon']) !== null && _e !== void 0 ? _e : '',
        countryRestrictions: o['countryRestrictions'] ? permissionListsFromJson(o['countryRestrictions']) : undefined,
        allowMultipleActivations: (_f = o['allowMultipleActivations']) !== null && _f !== void 0 ? _f : false,
        childActivatableApps: ((_g = o['childActivatableApps']) !== null && _g !== void 0 ? _g : []).map(e => activatableAppFromJson(e)),
    };
}
export function listActivatableAppsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.whitelabelOverrideKey !== undefined)
        o['whitelabelOverrideKey'] = m.whitelabelOverrideKey;
    return o;
}
export function listActivatableAppsRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
        cursor: (_c = o['cursor']) !== null && _c !== void 0 ? _c : '',
        marketId: (_d = o['marketId']) !== null && _d !== void 0 ? _d : '',
        whitelabelOverrideKey: (_e = o['whitelabelOverrideKey']) !== null && _e !== void 0 ? _e : '',
    };
}
export function listActivatableAppsResponseToJson(m) {
    const o = {};
    if (m.activatableApps !== undefined) {
        o['activatableApps'] = m.activatableApps.map(e => activatableAppToJson(e));
    }
    return o;
}
export function listActivatableAppsResponseFromJson(o) {
    var _a;
    return {
        activatableApps: ((_a = o['activatableApps']) !== null && _a !== void 0 ? _a : []).map(e => activatableAppFromJson(e)),
    };
}
export function getMultiAddonsByAppRequestToJson(m) {
    const o = {};
    if (m.appIds !== undefined) {
        o['appIds'] = m.appIds.map(e => e);
    }
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.whitelabelOverrideKey !== undefined)
        o['whitelabelOverrideKey'] = m.whitelabelOverrideKey;
    return o;
}
export function getMultiAddonsByAppRequestFromJson(o) {
    var _a, _b, _c;
    return {
        appIds: ((_a = o['appIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        whitelabelOverrideKey: (_c = o['whitelabelOverrideKey']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getMultiAddonsByAppResponseToJson(m) {
    const o = {};
    if (m.addonMap !== undefined) {
        const map = {};
        for (const [k, v] of Object.entries(m.addonMap)) {
            map[k] = getMultiAddonsByAppResponseAddonListContainerToJson(v);
        }
        o['addonMap'] = map;
    }
    return o;
}
export function getMultiAddonsByAppResponseFromJson(o) {
    return {
        addonMap: o['addonMap']
            ? Object.fromEntries(Object.entries(o['addonMap']).map(([k, v]) => [k, getMultiAddonsByAppResponseAddonListContainerFromJson(v)]))
            : {},
    };
}
export function getMultiAddonsByAppResponseAddonListContainerToJson(m) {
    const o = {};
    if (m.addons !== undefined) {
        o['addons'] = m.addons.map(e => addonToJson(e));
    }
    return o;
}
export function getMultiAddonsByAppResponseAddonListContainerFromJson(o) {
    var _a;
    return {
        addons: ((_a = o['addons']) !== null && _a !== void 0 ? _a : []).map(e => addonFromJson(e)),
    };
}
export function listDistributedAppIdsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.filters !== undefined)
        o['filters'] = listDistributedAppIdsRequestListDistributedAppIdsRequestFiltersToJson(m.filters);
    return o;
}
export function listDistributedAppIdsRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        filters: o['filters'] ? listDistributedAppIdsRequestListDistributedAppIdsRequestFiltersFromJson(o['filters']) : undefined,
    };
}
export function listDistributedAppIdsRequestListDistributedAppIdsRequestFiltersToJson(m) {
    const o = {};
    if (m.appTypes !== undefined) {
        o['appTypes'] = m.appTypes.map(e => e);
    }
    return o;
}
export function listDistributedAppIdsRequestListDistributedAppIdsRequestFiltersFromJson(o) {
    var _a;
    return {
        appTypes: ((_a = o['appTypes']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function listDistributedAppIdsResponseToJson(m) {
    const o = {};
    if (m.appIds !== undefined) {
        o['appIds'] = m.appIds.map(e => e);
    }
    return o;
}
export function listDistributedAppIdsResponseFromJson(o) {
    var _a;
    return {
        appIds: ((_a = o['appIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function isAppDistributedToPartnerRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function isAppDistributedToPartnerRequestFromJson(o) {
    var _a, _b;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function isAppDistributedToPartnerResponseToJson(m) {
    const o = {};
    if (m.isDistributed !== undefined)
        o['isDistributed'] = m.isDistributed;
    return o;
}
export function isAppDistributedToPartnerResponseFromJson(o) {
    var _a;
    return {
        isDistributed: (_a = o['isDistributed']) !== null && _a !== void 0 ? _a : false,
    };
}
export function areAppsDistributedToPartnerRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.appIds !== undefined) {
        o['appIds'] = m.appIds.map(e => e);
    }
    return o;
}
export function areAppsDistributedToPartnerRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        appIds: ((_b = o['appIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function areAppsDistributedToPartnerResponseToJson(m) {
    const o = {};
    if (m.areAppsDistributed !== undefined) {
        o['areAppsDistributed'] = m.areAppsDistributed.map(e => areAppsDistributedToPartnerResponseAppDistributedContainerToJson(e));
    }
    return o;
}
export function areAppsDistributedToPartnerResponseFromJson(o) {
    var _a;
    return {
        areAppsDistributed: ((_a = o['areAppsDistributed']) !== null && _a !== void 0 ? _a : []).map(e => areAppsDistributedToPartnerResponseAppDistributedContainerFromJson(e)),
    };
}
export function areAppsDistributedToPartnerResponseAppDistributedContainerToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.isDistributed !== undefined)
        o['isDistributed'] = m.isDistributed;
    if (m.isSolelyDistributedToPartner !== undefined)
        o['isSolelyDistributedToPartner'] = m.isSolelyDistributedToPartner;
    return o;
}
export function areAppsDistributedToPartnerResponseAppDistributedContainerFromJson(o) {
    var _a, _b, _c;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        isDistributed: (_b = o['isDistributed']) !== null && _b !== void 0 ? _b : false,
        isSolelyDistributedToPartner: (_c = o['isSolelyDistributedToPartner']) !== null && _c !== void 0 ? _c : false,
    };
}
export function packageScopeToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketIds !== undefined) {
        o['marketIds'] = m.marketIds.map(e => e);
    }
    return o;
}
export function packageScopeFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketIds: ((_b = o['marketIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function packageIdContainerToJson(m) {
    const o = {};
    if (m.packageIds !== undefined) {
        o['packageIds'] = m.packageIds.map(e => e);
    }
    return o;
}
export function packageIdContainerFromJson(o) {
    var _a;
    return {
        packageIds: ((_a = o['packageIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function bulkCopyPackageRequestToJson(m) {
    const o = {};
    if (m.source !== undefined)
        o['source'] = bulkCopyPackageRequestPackageSourceToJson(m.source);
    if (m.target !== undefined)
        o['target'] = packageScopeToJson(m.target);
    return o;
}
export function bulkCopyPackageRequestFromJson(o) {
    return {
        source: o['source'] ? bulkCopyPackageRequestPackageSourceFromJson(o['source']) : undefined,
        target: o['target'] ? packageScopeFromJson(o['target']) : undefined,
    };
}
export function bulkCopyPackageRequestPackageSourceToJson(m) {
    const o = {};
    if (m.source !== undefined) {
        if (m.source.type === 'packageIdsContainer') {
            o['packageIdsContainer'] = packageIdContainerToJson(m.source.packageIdsContainer);
        }
        if (m.source.type === 'scope') {
            o['scope'] = packageScopeToJson(m.source.scope);
        }
    }
    else {
        if (m.packageIdsContainer !== undefined)
            o['packageIdsContainer'] = packageIdContainerToJson(m.packageIdsContainer);
        if (m.scope !== undefined)
            o['scope'] = packageScopeToJson(m.scope);
    }
    return o;
}
export function bulkCopyPackageRequestPackageSourceFromJson(o) {
    return {
        source: (() => {
            if (o['packageIdsContainer'] !== undefined)
                return { type: 'packageIdsContainer', packageIdsContainer: o['packageIdsContainer'] ? packageIdContainerFromJson(o['packageIdsContainer']) : undefined };
            if (o['scope'] !== undefined)
                return { type: 'scope', scope: o['scope'] ? packageScopeFromJson(o['scope']) : undefined };
            return undefined;
        })(),
        packageIdsContainer: o['packageIdsContainer'] !== undefined ? o['packageIdsContainer'] ? packageIdContainerFromJson(o['packageIdsContainer']) : undefined : undefined,
        scope: o['scope'] !== undefined ? o['scope'] ? packageScopeFromJson(o['scope']) : undefined : undefined,
    };
}
export function bulkCopyPackageResponseToJson(m) {
    const o = {};
    return o;
}
export function bulkCopyPackageResponseFromJson(o) {
    return {};
}
export function copyPackageRequestToJson(m) {
    const o = {};
    if (m.packageId !== undefined)
        o['packageId'] = m.packageId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.pricing !== undefined)
        o['pricing'] = pricingToJson(m.pricing);
    if (m.publish !== undefined)
        o['publish'] = m.publish;
    if (m.packageDestination !== undefined)
        o['packageDestination'] = packageScopeToJson(m.packageDestination);
    return o;
}
export function copyPackageRequestFromJson(o) {
    var _a, _b, _c;
    return {
        packageId: (_a = o['packageId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        pricing: o['pricing'] ? pricingFromJson(o['pricing']) : undefined,
        publish: (_c = o['publish']) !== null && _c !== void 0 ? _c : false,
        packageDestination: o['packageDestination'] ? packageScopeFromJson(o['packageDestination']) : undefined,
    };
}
export function copyPackageResponseToJson(m) {
    const o = {};
    if (m.failedScope !== undefined)
        o['failedScope'] = packageScopeToJson(m.failedScope);
    return o;
}
export function copyPackageResponseFromJson(o) {
    return {
        failedScope: o['failedScope'] ? packageScopeFromJson(o['failedScope']) : undefined,
    };
}
export function partnerAppRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    return o;
}
export function partnerAppRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        appId: (_b = o['appId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getMultiPartnerAppEnablementStatusRequestToJson(m) {
    const o = {};
    if (m.partnerAppRequest !== undefined) {
        o['partnerAppRequest'] = m.partnerAppRequest.map(e => partnerAppRequestToJson(e));
    }
    return o;
}
export function getMultiPartnerAppEnablementStatusRequestFromJson(o) {
    var _a;
    return {
        partnerAppRequest: ((_a = o['partnerAppRequest']) !== null && _a !== void 0 ? _a : []).map(e => partnerAppRequestFromJson(e)),
    };
}
export function updateEventToJson(m) {
    const o = {};
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp.toISOString();
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.origin !== undefined)
        o['origin'] = m.origin;
    return o;
}
export function updateEventFromJson(o) {
    var _a, _b;
    return {
        timestamp: o['timestamp'] ? new Date(o['timestamp']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        status: (_a = o['status']) !== null && _a !== void 0 ? _a : 'NOT_SPECIFIED',
        origin: (_b = o['origin']) !== null && _b !== void 0 ? _b : '',
    };
}
export function partnerAppResponseToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.updateEvents !== undefined) {
        o['updateEvents'] = m.updateEvents.map(e => updateEventToJson(e));
    }
    return o;
}
export function partnerAppResponseFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        appId: (_b = o['appId']) !== null && _b !== void 0 ? _b : '',
        status: (_c = o['status']) !== null && _c !== void 0 ? _c : 'NOT_SPECIFIED',
        updateEvents: ((_d = o['updateEvents']) !== null && _d !== void 0 ? _d : []).map(e => updateEventFromJson(e)),
    };
}
export function getMultiPartnerAppEnablementStatusResponseToJson(m) {
    const o = {};
    if (m.partnerAppResponse !== undefined) {
        o['partnerAppResponse'] = m.partnerAppResponse.map(e => partnerAppResponseToJson(e));
    }
    return o;
}
export function getMultiPartnerAppEnablementStatusResponseFromJson(o) {
    var _a;
    return {
        partnerAppResponse: ((_a = o['partnerAppResponse']) !== null && _a !== void 0 ? _a : []).map(e => partnerAppResponseFromJson(e)),
    };
}
export function listPartnerAppEnablementStatusRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function listPartnerAppEnablementStatusRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listPartnerAppEnablementStatusResponseToJson(m) {
    const o = {};
    if (m.partnerAppResponse !== undefined) {
        o['partnerAppResponse'] = m.partnerAppResponse.map(e => partnerAppResponseToJson(e));
    }
    return o;
}
export function listPartnerAppEnablementStatusResponseFromJson(o) {
    var _a;
    return {
        partnerAppResponse: ((_a = o['partnerAppResponse']) !== null && _a !== void 0 ? _a : []).map(e => partnerAppResponseFromJson(e)),
    };
}
export function getMultiIsAppEnabledRequestToJson(m) {
    const o = {};
    if (m.appIds !== undefined) {
        o['appIds'] = m.appIds.map(e => e);
    }
    return o;
}
export function getMultiIsAppEnabledRequestFromJson(o) {
    var _a;
    return {
        appIds: ((_a = o['appIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiIsAppEnabledResponseToJson(m) {
    const o = {};
    if (m.appEnablement !== undefined) {
        o['appEnablement'] = m.appEnablement.map(e => getMultiIsAppEnabledResponseAppEnablementToJson(e));
    }
    return o;
}
export function getMultiIsAppEnabledResponseFromJson(o) {
    var _a;
    return {
        appEnablement: ((_a = o['appEnablement']) !== null && _a !== void 0 ? _a : []).map(e => getMultiIsAppEnabledResponseAppEnablementFromJson(e)),
    };
}
export function getMultiIsAppEnabledResponseAppEnablementToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    return o;
}
export function getMultiIsAppEnabledResponseAppEnablementFromJson(o) {
    var _a, _b;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        enabled: (_b = o['enabled']) !== null && _b !== void 0 ? _b : false,
    };
}
export function disableAppForPartnerRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.origin !== undefined)
        o['origin'] = m.origin;
    return o;
}
export function disableAppForPartnerRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        appId: (_b = o['appId']) !== null && _b !== void 0 ? _b : '',
        origin: (_c = o['origin']) !== null && _c !== void 0 ? _c : '',
    };
}
export function enableAppForPartnerRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.origin !== undefined)
        o['origin'] = m.origin;
    return o;
}
export function enableAppForPartnerRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        appId: (_b = o['appId']) !== null && _b !== void 0 ? _b : '',
        origin: (_c = o['origin']) !== null && _c !== void 0 ? _c : '',
    };
}
export function bulkEnableAppForAllPartnersRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    return o;
}
export function bulkEnableAppForAllPartnersRequestFromJson(o) {
    var _a;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function cleanupRetiredProductRequestToJson(m) {
    const o = {};
    if (m.productId !== undefined)
        o['productId'] = m.productId;
    if (m.dryRun !== undefined)
        o['dryRun'] = m.dryRun;
    return o;
}
export function cleanupRetiredProductRequestFromJson(o) {
    var _a, _b;
    return {
        productId: (_a = o['productId']) !== null && _a !== void 0 ? _a : '',
        dryRun: (_b = o['dryRun']) !== null && _b !== void 0 ? _b : false,
    };
}
export function addProductToStoreRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    if (m.retailPrice !== undefined)
        o['retailPrice'] = retailPriceToJson(m.retailPrice);
    if (m.publishImmediately !== undefined)
        o['publishImmediately'] = m.publishImmediately;
    return o;
}
export function addProductToStoreRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        appId: (_c = o['appId']) !== null && _c !== void 0 ? _c : '',
        editionId: (_d = o['editionId']) !== null && _d !== void 0 ? _d : '',
        retailPrice: o['retailPrice'] ? retailPriceFromJson(o['retailPrice']) : undefined,
        publishImmediately: (_e = o['publishImmediately']) !== null && _e !== void 0 ? _e : false,
    };
}
export function listPackageIDsForProductRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    return o;
}
export function listPackageIDsForProductRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        appId: (_c = o['appId']) !== null && _c !== void 0 ? _c : '',
        editionId: (_d = o['editionId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function listPackageIDsForProductResponseToJson(m) {
    const o = {};
    if (m.packageIds !== undefined) {
        o['packageIds'] = m.packageIds.map(e => e);
    }
    return o;
}
export function listPackageIDsForProductResponseFromJson(o) {
    var _a;
    return {
        packageIds: ((_a = o['packageIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function partnerMarketContainerToJson(m) {
    const o = {};
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function partnerMarketContainerFromJson(o) {
    var _a, _b;
    return {
        marketId: (_a = o['marketId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getRetailPriceRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    if (m.dontUseMsrp !== undefined)
        o['dontUseMsrp'] = m.dontUseMsrp;
    if (m.retailPriceGrouping !== undefined) {
        if (m.retailPriceGrouping.type === 'businessId') {
            o['businessId'] = m.retailPriceGrouping.businessId;
        }
        if (m.retailPriceGrouping.type === 'partnerMarket') {
            o['partnerMarket'] = partnerMarketContainerToJson(m.retailPriceGrouping.partnerMarket);
        }
    }
    else {
        if (m.businessId !== undefined)
            o['businessId'] = m.businessId;
        if (m.partnerMarket !== undefined)
            o['partnerMarket'] = partnerMarketContainerToJson(m.partnerMarket);
    }
    return o;
}
export function getRetailPriceRequestFromJson(o) {
    var _a, _b, _c;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        editionId: (_b = o['editionId']) !== null && _b !== void 0 ? _b : '',
        dontUseMsrp: (_c = o['dontUseMsrp']) !== null && _c !== void 0 ? _c : false,
        retailPriceGrouping: (() => {
            if (o['businessId'] !== undefined)
                return { type: 'businessId', businessId: o['businessId'] };
            if (o['partnerMarket'] !== undefined)
                return { type: 'partnerMarket', partnerMarket: o['partnerMarket'] ? partnerMarketContainerFromJson(o['partnerMarket']) : undefined };
            return undefined;
        })(),
        businessId: o['businessId'] !== undefined ? o['businessId'] : undefined,
        partnerMarket: o['partnerMarket'] !== undefined ? o['partnerMarket'] ? partnerMarketContainerFromJson(o['partnerMarket']) : undefined : undefined,
    };
}
export function getRetailPriceResponseToJson(m) {
    const o = {};
    if (m.retailPrice !== undefined)
        o['retailPrice'] = retailPriceToJson(m.retailPrice);
    return o;
}
export function getRetailPriceResponseFromJson(o) {
    return {
        retailPrice: o['retailPrice'] ? retailPriceFromJson(o['retailPrice']) : undefined,
    };
}
export function productIdentifierToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    return o;
}
export function productIdentifierFromJson(o) {
    var _a, _b;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        editionId: (_b = o['editionId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getMultiRetailPriceRequestToJson(m) {
    const o = {};
    if (m.productIds !== undefined) {
        o['productIds'] = m.productIds.map(e => productIdentifierToJson(e));
    }
    if (m.retailPriceGrouping !== undefined) {
        if (m.retailPriceGrouping.type === 'businessId') {
            o['businessId'] = m.retailPriceGrouping.businessId;
        }
        if (m.retailPriceGrouping.type === 'partnerMarket') {
            o['partnerMarket'] = partnerMarketContainerToJson(m.retailPriceGrouping.partnerMarket);
        }
    }
    else {
        if (m.businessId !== undefined)
            o['businessId'] = m.businessId;
        if (m.partnerMarket !== undefined)
            o['partnerMarket'] = partnerMarketContainerToJson(m.partnerMarket);
    }
    return o;
}
export function getMultiRetailPriceRequestFromJson(o) {
    var _a;
    return {
        productIds: ((_a = o['productIds']) !== null && _a !== void 0 ? _a : []).map(e => productIdentifierFromJson(e)),
        retailPriceGrouping: (() => {
            if (o['businessId'] !== undefined)
                return { type: 'businessId', businessId: o['businessId'] };
            if (o['partnerMarket'] !== undefined)
                return { type: 'partnerMarket', partnerMarket: o['partnerMarket'] ? partnerMarketContainerFromJson(o['partnerMarket']) : undefined };
            return undefined;
        })(),
        businessId: o['businessId'] !== undefined ? o['businessId'] : undefined,
        partnerMarket: o['partnerMarket'] !== undefined ? o['partnerMarket'] ? partnerMarketContainerFromJson(o['partnerMarket']) : undefined : undefined,
    };
}
export function getMultiRetailPriceResponseToJson(m) {
    const o = {};
    if (m.retailPrices !== undefined) {
        o['retailPrices'] = m.retailPrices.map(e => getMultiRetailPriceResponseRetailPriceResponseToJson(e));
    }
    return o;
}
export function getMultiRetailPriceResponseFromJson(o) {
    var _a;
    return {
        retailPrices: ((_a = o['retailPrices']) !== null && _a !== void 0 ? _a : []).map(e => getMultiRetailPriceResponseRetailPriceResponseFromJson(e)),
    };
}
export function getMultiRetailPriceResponseRetailPriceResponseToJson(m) {
    const o = {};
    if (m.productId !== undefined)
        o['productId'] = productIdentifierToJson(m.productId);
    if (m.retailPrice !== undefined)
        o['retailPrice'] = retailPriceToJson(m.retailPrice);
    return o;
}
export function getMultiRetailPriceResponseRetailPriceResponseFromJson(o) {
    return {
        productId: o['productId'] ? productIdentifierFromJson(o['productId']) : undefined,
        retailPrice: o['retailPrice'] ? retailPriceFromJson(o['retailPrice']) : undefined,
    };
}
export function createOrUpdateRetailPriceRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.retailPrice !== undefined)
        o['retailPrice'] = retailPriceToJson(m.retailPrice);
    return o;
}
export function createOrUpdateRetailPriceRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        editionId: (_b = o['editionId']) !== null && _b !== void 0 ? _b : '',
        partnerId: (_c = o['partnerId']) !== null && _c !== void 0 ? _c : '',
        marketId: (_d = o['marketId']) !== null && _d !== void 0 ? _d : '',
        retailPrice: o['retailPrice'] ? retailPriceFromJson(o['retailPrice']) : undefined,
    };
}
export function deleteRetailPriceRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    return o;
}
export function deleteRetailPriceRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        editionId: (_b = o['editionId']) !== null && _b !== void 0 ? _b : '',
        partnerId: (_c = o['partnerId']) !== null && _c !== void 0 ? _c : '',
        marketId: (_d = o['marketId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function convertRetailPricesForMarketRequestToJson(m) {
    const o = {};
    if (m.partnerMarket !== undefined)
        o['partnerMarket'] = partnerMarketContainerToJson(m.partnerMarket);
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    if (m.conversionRate !== undefined)
        o['conversionRate'] = m.conversionRate;
    return o;
}
export function convertRetailPricesForMarketRequestFromJson(o) {
    var _a, _b;
    return {
        partnerMarket: o['partnerMarket'] ? partnerMarketContainerFromJson(o['partnerMarket']) : undefined,
        currency: (_a = o['currency']) !== null && _a !== void 0 ? _a : '',
        conversionRate: (_b = o['conversionRate']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function buyItNowLinkToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.packageId !== undefined)
        o['packageId'] = m.packageId;
    if (m.linkId !== undefined)
        o['linkId'] = m.linkId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.link !== undefined)
        o['link'] = m.link;
    return o;
}
export function buyItNowLinkFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        packageId: (_c = o['packageId']) !== null && _c !== void 0 ? _c : '',
        linkId: (_d = o['linkId']) !== null && _d !== void 0 ? _d : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        link: (_e = o['link']) !== null && _e !== void 0 ? _e : '',
    };
}
export function generateBuyItNowLinkRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.packageId !== undefined)
        o['packageId'] = m.packageId;
    return o;
}
export function generateBuyItNowLinkRequestFromJson(o) {
    var _a, _b, _c;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        packageId: (_c = o['packageId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function generateBuyItNowLinkResponseToJson(m) {
    const o = {};
    if (m.link !== undefined)
        o['link'] = buyItNowLinkToJson(m.link);
    if (m.shortenedUrl !== undefined)
        o['shortenedUrl'] = m.shortenedUrl;
    return o;
}
export function generateBuyItNowLinkResponseFromJson(o) {
    var _a;
    return {
        link: o['link'] ? buyItNowLinkFromJson(o['link']) : undefined,
        shortenedUrl: (_a = o['shortenedUrl']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getBuyItNowLinkByLinkIDRequestToJson(m) {
    const o = {};
    if (m.linkId !== undefined)
        o['linkId'] = m.linkId;
    return o;
}
export function getBuyItNowLinkByLinkIDRequestFromJson(o) {
    var _a;
    return {
        linkId: (_a = o['linkId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getBuyItNowLinkByLinkIDResponseToJson(m) {
    const o = {};
    if (m.link !== undefined)
        o['link'] = buyItNowLinkToJson(m.link);
    return o;
}
export function getBuyItNowLinkByLinkIDResponseFromJson(o) {
    return {
        link: o['link'] ? buyItNowLinkFromJson(o['link']) : undefined,
    };
}
export function shoppingCartToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.items !== undefined) {
        o['items'] = m.items.map(e => shoppingCartShoppingCartItemToJson(e));
    }
    return o;
}
export function shoppingCartFromJson(o) {
    var _a, _b, _c;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
        items: ((_c = o['items']) !== null && _c !== void 0 ? _c : []).map(e => shoppingCartShoppingCartItemFromJson(e)),
    };
}
export function shoppingCartShoppingCartItemToJson(m) {
    const o = {};
    if (m.itemId !== undefined)
        o['itemId'] = m.itemId;
    if (m.quantity !== undefined)
        o['quantity'] = m.quantity;
    if (m.itemType !== undefined)
        o['itemType'] = m.itemType;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    return o;
}
export function shoppingCartShoppingCartItemFromJson(o) {
    var _a, _b, _c, _d;
    return {
        itemId: (_a = o['itemId']) !== null && _a !== void 0 ? _a : '',
        quantity: (_b = o['quantity']) !== null && _b !== void 0 ? _b : 0,
        itemType: (_c = o['itemType']) !== null && _c !== void 0 ? _c : 'SHOPPING_CART_ITEM_TYPE_INVALID',
        editionId: (_d = o['editionId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function getShoppingCartRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function getShoppingCartRequestFromJson(o) {
    var _a, _b;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
        userId: (_b = o['userId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function addToShoppingCartRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.itemId !== undefined)
        o['itemId'] = m.itemId;
    if (m.itemType !== undefined)
        o['itemType'] = m.itemType;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    return o;
}
export function addToShoppingCartRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
        itemId: (_b = o['itemId']) !== null && _b !== void 0 ? _b : '',
        itemType: (_c = o['itemType']) !== null && _c !== void 0 ? _c : 'SHOPPING_CART_ITEM_TYPE_INVALID',
        editionId: (_d = o['editionId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function addMultiToShoppingCartRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.items !== undefined) {
        o['items'] = m.items.map(e => addMultiToShoppingCartRequestItemToJson(e));
    }
    return o;
}
export function addMultiToShoppingCartRequestFromJson(o) {
    var _a, _b;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
        items: ((_b = o['items']) !== null && _b !== void 0 ? _b : []).map(e => addMultiToShoppingCartRequestItemFromJson(e)),
    };
}
export function addMultiToShoppingCartRequestItemToJson(m) {
    const o = {};
    if (m.itemId !== undefined)
        o['itemId'] = m.itemId;
    if (m.itemType !== undefined)
        o['itemType'] = m.itemType;
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    return o;
}
export function addMultiToShoppingCartRequestItemFromJson(o) {
    var _a, _b, _c;
    return {
        itemId: (_a = o['itemId']) !== null && _a !== void 0 ? _a : '',
        itemType: (_b = o['itemType']) !== null && _b !== void 0 ? _b : 'SHOPPING_CART_ITEM_TYPE_INVALID',
        editionId: (_c = o['editionId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function updateItemQuantityRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.itemId !== undefined)
        o['itemId'] = m.itemId;
    if (m.quantity !== undefined)
        o['quantity'] = m.quantity;
    return o;
}
export function updateItemQuantityRequestFromJson(o) {
    var _a, _b, _c;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
        itemId: (_b = o['itemId']) !== null && _b !== void 0 ? _b : '',
        quantity: (_c = o['quantity']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function removeFromShoppingCartRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.itemId !== undefined)
        o['itemId'] = m.itemId;
    return o;
}
export function removeFromShoppingCartRequestFromJson(o) {
    var _a, _b;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
        itemId: (_b = o['itemId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function removeMultiFromShoppingCartRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    if (m.itemIds !== undefined) {
        o['itemIds'] = m.itemIds.map(e => e);
    }
    return o;
}
export function removeMultiFromShoppingCartRequestFromJson(o) {
    var _a, _b;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
        itemIds: ((_b = o['itemIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function clearShoppingCartRequestToJson(m) {
    const o = {};
    if (m.businessId !== undefined)
        o['businessId'] = m.businessId;
    return o;
}
export function clearShoppingCartRequestFromJson(o) {
    var _a;
    return {
        businessId: (_a = o['businessId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function shoppingCartResponseToJson(m) {
    const o = {};
    if (m.cart !== undefined)
        o['cart'] = shoppingCartToJson(m.cart);
    return o;
}
export function shoppingCartResponseFromJson(o) {
    return {
        cart: o['cart'] ? shoppingCartFromJson(o['cart']) : undefined,
    };
}
export function isShoppingCartEnabledRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.storeId !== undefined)
        o['storeId'] = m.storeId;
    return o;
}
export function isShoppingCartEnabledRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        storeId: (_b = o['storeId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function isShoppingCartEnabledResponseToJson(m) {
    const o = {};
    if (m.enabled !== undefined)
        o['enabled'] = m.enabled;
    return o;
}
export function isShoppingCartEnabledResponseFromJson(o) {
    var _a;
    return {
        enabled: (_a = o['enabled']) !== null && _a !== void 0 ? _a : false,
    };
}
export function storeIdentifierToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    return o;
}
export function storeIdentifierFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function categoryToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.categoryId !== undefined)
        o['categoryId'] = m.categoryId;
    if (m.categoryName !== undefined)
        o['categoryName'] = m.categoryName;
    if (m.visibleInStore !== undefined)
        o['visibleInStore'] = m.visibleInStore;
    if (m.packageIds !== undefined) {
        o['packageIds'] = m.packageIds.map(e => e);
    }
    return o;
}
export function categoryFromJson(o) {
    var _a, _b, _c, _d;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        categoryId: (_a = o['categoryId']) !== null && _a !== void 0 ? _a : '',
        categoryName: (_b = o['categoryName']) !== null && _b !== void 0 ? _b : '',
        visibleInStore: (_c = o['visibleInStore']) !== null && _c !== void 0 ? _c : false,
        packageIds: ((_d = o['packageIds']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function publicStoreThemeToJson(m) {
    const o = {};
    if (m.logoBarColor !== undefined)
        o['logoBarColor'] = m.logoBarColor;
    if (m.backgroundColor !== undefined)
        o['backgroundColor'] = m.backgroundColor;
    if (m.primaryFontColor !== undefined)
        o['primaryFontColor'] = m.primaryFontColor;
    if (m.secondaryFontColor !== undefined)
        o['secondaryFontColor'] = m.secondaryFontColor;
    if (m.accentColor !== undefined)
        o['accentColor'] = m.accentColor;
    if (m.primaryCategoryColor !== undefined)
        o['primaryCategoryColor'] = m.primaryCategoryColor;
    if (m.secondaryCategoryColor !== undefined)
        o['secondaryCategoryColor'] = m.secondaryCategoryColor;
    return o;
}
export function publicStoreThemeFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        logoBarColor: (_a = o['logoBarColor']) !== null && _a !== void 0 ? _a : '',
        backgroundColor: (_b = o['backgroundColor']) !== null && _b !== void 0 ? _b : '',
        primaryFontColor: (_c = o['primaryFontColor']) !== null && _c !== void 0 ? _c : '',
        secondaryFontColor: (_d = o['secondaryFontColor']) !== null && _d !== void 0 ? _d : '',
        accentColor: (_e = o['accentColor']) !== null && _e !== void 0 ? _e : '',
        primaryCategoryColor: (_f = o['primaryCategoryColor']) !== null && _f !== void 0 ? _f : '',
        secondaryCategoryColor: (_g = o['secondaryCategoryColor']) !== null && _g !== void 0 ? _g : '',
    };
}
export function getStoreRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    return o;
}
export function getStoreRequestFromJson(o) {
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
    };
}
export function getStoreResponseToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.publicStoreSalesPersonId !== undefined)
        o['publicStoreSalesPersonId'] = m.publicStoreSalesPersonId;
    if (m.useCustomCategories !== undefined)
        o['useCustomCategories'] = m.useCustomCategories;
    if (m.categoryOrder !== undefined) {
        o['categoryOrder'] = m.categoryOrder.map(e => e);
    }
    return o;
}
export function getStoreResponseFromJson(o) {
    var _a, _b, _c;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        publicStoreSalesPersonId: (_a = o['publicStoreSalesPersonId']) !== null && _a !== void 0 ? _a : '',
        useCustomCategories: (_b = o['useCustomCategories']) !== null && _b !== void 0 ? _b : false,
        categoryOrder: ((_c = o['categoryOrder']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function getCategoriesForStoreRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    return o;
}
export function getCategoriesForStoreRequestFromJson(o) {
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
    };
}
export function getCategoriesForStoreResponseToJson(m) {
    const o = {};
    if (m.categories !== undefined) {
        o['categories'] = m.categories.map(e => categoryToJson(e));
    }
    return o;
}
export function getCategoriesForStoreResponseFromJson(o) {
    var _a;
    return {
        categories: ((_a = o['categories']) !== null && _a !== void 0 ? _a : []).map(e => categoryFromJson(e)),
    };
}
export function updateStoreRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.publicStoreSalesPersonId !== undefined)
        o['publicStoreSalesPersonId'] = m.publicStoreSalesPersonId;
    if (m.useCustomCategories !== undefined)
        o['useCustomCategories'] = m.useCustomCategories;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateStoreRequestFromJson(o) {
    var _a, _b;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        publicStoreSalesPersonId: (_a = o['publicStoreSalesPersonId']) !== null && _a !== void 0 ? _a : '',
        useCustomCategories: (_b = o['useCustomCategories']) !== null && _b !== void 0 ? _b : false,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function setStoreCategoryOrderRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.orderedCategoryIds !== undefined) {
        o['orderedCategoryIds'] = m.orderedCategoryIds.map(e => e);
    }
    return o;
}
export function setStoreCategoryOrderRequestFromJson(o) {
    var _a;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        orderedCategoryIds: ((_a = o['orderedCategoryIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function createStoreCategoryRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.name !== undefined)
        o['name'] = m.name;
    return o;
}
export function createStoreCategoryRequestFromJson(o) {
    var _a;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
    };
}
export function createStoreCategoryResponseToJson(m) {
    const o = {};
    if (m.category !== undefined)
        o['category'] = categoryToJson(m.category);
    return o;
}
export function createStoreCategoryResponseFromJson(o) {
    return {
        category: o['category'] ? categoryFromJson(o['category']) : undefined,
    };
}
export function deleteStoreCategoryRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.categoryId !== undefined)
        o['categoryId'] = m.categoryId;
    return o;
}
export function deleteStoreCategoryRequestFromJson(o) {
    var _a;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        categoryId: (_a = o['categoryId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateStoreCategoryRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.categoryId !== undefined)
        o['categoryId'] = m.categoryId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.visibleInStore !== undefined)
        o['visibleInStore'] = m.visibleInStore;
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateStoreCategoryRequestFromJson(o) {
    var _a, _b, _c;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        categoryId: (_a = o['categoryId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        visibleInStore: (_c = o['visibleInStore']) !== null && _c !== void 0 ? _c : false,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function listCategoriesForPackageRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.packageId !== undefined)
        o['packageId'] = m.packageId;
    return o;
}
export function listCategoriesForPackageRequestFromJson(o) {
    var _a;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        packageId: (_a = o['packageId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listCategoriesForPackageResponseToJson(m) {
    const o = {};
    if (m.categories !== undefined) {
        o['categories'] = m.categories.map(e => categoryToJson(e));
    }
    return o;
}
export function listCategoriesForPackageResponseFromJson(o) {
    var _a;
    return {
        categories: ((_a = o['categories']) !== null && _a !== void 0 ? _a : []).map(e => categoryFromJson(e)),
    };
}
export function setPackagesInCategoryRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.packageIds !== undefined) {
        o['packageIds'] = m.packageIds.map(e => e);
    }
    if (m.categoryId !== undefined)
        o['categoryId'] = m.categoryId;
    return o;
}
export function setPackagesInCategoryRequestFromJson(o) {
    var _a, _b;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        packageIds: ((_a = o['packageIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        categoryId: (_b = o['categoryId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function setCategoriesForPackageRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.packageId !== undefined)
        o['packageId'] = m.packageId;
    if (m.categoryIds !== undefined) {
        o['categoryIds'] = m.categoryIds.map(e => e);
    }
    return o;
}
export function setCategoriesForPackageRequestFromJson(o) {
    var _a, _b;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        packageId: (_a = o['packageId']) !== null && _a !== void 0 ? _a : '',
        categoryIds: ((_b = o['categoryIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getStoreWithCategoriesRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.bypassCache !== undefined)
        o['bypassCache'] = m.bypassCache;
    if (m.getLegacyLmiCategories !== undefined)
        o['getLegacyLmiCategories'] = m.getLegacyLmiCategories;
    return o;
}
export function getStoreWithCategoriesRequestFromJson(o) {
    var _a, _b;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        bypassCache: (_a = o['bypassCache']) !== null && _a !== void 0 ? _a : false,
        getLegacyLmiCategories: (_b = o['getLegacyLmiCategories']) !== null && _b !== void 0 ? _b : false,
    };
}
export function getStoreWithCategoriesResponseToJson(m) {
    const o = {};
    if (m.categories !== undefined) {
        o['categories'] = m.categories.map(e => categoryToJson(e));
    }
    if (m.publicStoreSalesPersonId !== undefined)
        o['publicStoreSalesPersonId'] = m.publicStoreSalesPersonId;
    return o;
}
export function getStoreWithCategoriesResponseFromJson(o) {
    var _a, _b;
    return {
        categories: ((_a = o['categories']) !== null && _a !== void 0 ? _a : []).map(e => categoryFromJson(e)),
        publicStoreSalesPersonId: (_b = o['publicStoreSalesPersonId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function enableCustomCategoriesForStoreRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    return o;
}
export function enableCustomCategoriesForStoreRequestFromJson(o) {
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
    };
}
export function enableCustomCategoriesForStoreResponseToJson(m) {
    const o = {};
    if (m.categories !== undefined) {
        o['categories'] = m.categories.map(e => categoryToJson(e));
    }
    return o;
}
export function enableCustomCategoriesForStoreResponseFromJson(o) {
    var _a;
    return {
        categories: ((_a = o['categories']) !== null && _a !== void 0 ? _a : []).map(e => categoryFromJson(e)),
    };
}
export function getPublicStoreThemeRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    return o;
}
export function getPublicStoreThemeRequestFromJson(o) {
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
    };
}
export function getPublicStoreThemeResponseToJson(m) {
    const o = {};
    if (m.publicStoreTheme !== undefined)
        o['publicStoreTheme'] = publicStoreThemeToJson(m.publicStoreTheme);
    return o;
}
export function getPublicStoreThemeResponseFromJson(o) {
    return {
        publicStoreTheme: o['publicStoreTheme'] ? publicStoreThemeFromJson(o['publicStoreTheme']) : undefined,
    };
}
export function updatePublicStoreThemeRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.publicStoreTheme !== undefined)
        o['publicStoreTheme'] = publicStoreThemeToJson(m.publicStoreTheme);
    return o;
}
export function updatePublicStoreThemeRequestFromJson(o) {
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        publicStoreTheme: o['publicStoreTheme'] ? publicStoreThemeFromJson(o['publicStoreTheme']) : undefined,
    };
}
export function addToStoreRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.referenceId !== undefined) {
        if (m.referenceId.type === 'appId') {
            o['appId'] = m.referenceId.appId;
        }
    }
    else {
        if (m.appId !== undefined)
            o['appId'] = m.appId;
    }
    return o;
}
export function addToStoreRequestFromJson(o) {
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        referenceId: (() => {
            if (o['appId'] !== undefined)
                return { type: 'appId', appId: o['appId'] };
            return undefined;
        })(),
        appId: o['appId'] !== undefined ? o['appId'] : undefined,
    };
}
export function addToStoresRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.storeIds !== undefined) {
        o['storeIds'] = m.storeIds.map(e => e);
    }
    if (m.itemId !== undefined)
        o['itemId'] = m.itemId;
    return o;
}
export function addToStoresRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        storeIds: ((_b = o['storeIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        itemId: (_c = o['itemId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function removeFromStoreRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.productReferenceId !== undefined)
        o['productReferenceId'] = m.productReferenceId;
    return o;
}
export function removeFromStoreRequestFromJson(o) {
    var _a;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        productReferenceId: (_a = o['productReferenceId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function checkProductVisibilityRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketIds !== undefined) {
        o['marketIds'] = m.marketIds.map(e => e);
    }
    if (m.productReferenceId !== undefined)
        o['productReferenceId'] = m.productReferenceId;
    return o;
}
export function checkProductVisibilityRequestFromJson(o) {
    var _a, _b, _c;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketIds: ((_b = o['marketIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
        productReferenceId: (_c = o['productReferenceId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function checkProductVisibilityResponseToJson(m) {
    const o = {};
    if (m.productVisibilty !== undefined) {
        const map = {};
        for (const [k, v] of Object.entries(m.productVisibilty)) {
            map[k] = v;
        }
        o['productVisibilty'] = map;
    }
    return o;
}
export function checkProductVisibilityResponseFromJson(o) {
    return {
        productVisibilty: o['productVisibilty']
            ? Object.fromEntries(Object.entries(o['productVisibilty']).map(([k, v]) => [k, v]))
            : {},
    };
}
export function productPricePreviewsToJson(m) {
    const o = {};
    if (m.productId !== undefined)
        o['productId'] = m.productId;
    if (m.productName !== undefined)
        o['productName'] = m.productName;
    if (m.storePreviews !== undefined) {
        o['storePreviews'] = m.storePreviews.map(e => storePricePreviewsToJson(e));
    }
    return o;
}
export function productPricePreviewsFromJson(o) {
    var _a, _b, _c;
    return {
        productId: (_a = o['productId']) !== null && _a !== void 0 ? _a : '',
        productName: (_b = o['productName']) !== null && _b !== void 0 ? _b : '',
        storePreviews: ((_c = o['storePreviews']) !== null && _c !== void 0 ? _c : []).map(e => storePricePreviewsFromJson(e)),
    };
}
export function storePricePreviewsToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.storeName !== undefined)
        o['storeName'] = m.storeName;
    if (m.prices !== undefined) {
        o['prices'] = m.prices.map(e => storePricePreviewToJson(e));
    }
    if (m.currency !== undefined)
        o['currency'] = m.currency;
    return o;
}
export function storePricePreviewsFromJson(o) {
    var _a, _b, _c;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        storeName: (_a = o['storeName']) !== null && _a !== void 0 ? _a : '',
        prices: ((_b = o['prices']) !== null && _b !== void 0 ? _b : []).map(e => storePricePreviewFromJson(e)),
        currency: (_c = o['currency']) !== null && _c !== void 0 ? _c : 'USD',
    };
}
export function storePricePreviewToJson(m) {
    const o = {};
    if (m.editionId !== undefined)
        o['editionId'] = m.editionId;
    if (m.editionName !== undefined)
        o['editionName'] = m.editionName;
    if (m.price !== undefined)
        o['price'] = m.price;
    if (m.frequency !== undefined)
        o['frequency'] = m.frequency;
    return o;
}
export function storePricePreviewFromJson(o) {
    var _a, _b, _c, _d;
    return {
        editionId: (_a = o['editionId']) !== null && _a !== void 0 ? _a : '',
        editionName: (_b = o['editionName']) !== null && _b !== void 0 ? _b : '',
        price: (_c = o['price']) !== null && _c !== void 0 ? _c : 0,
        frequency: (_d = o['frequency']) !== null && _d !== void 0 ? _d : 'MONTHLY',
    };
}
export function listStorePricePreviewsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.productId !== undefined)
        o['productId'] = m.productId;
    return o;
}
export function listStorePricePreviewsRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        productId: (_b = o['productId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listStorePricePreviewsResponseToJson(m) {
    const o = {};
    if (m.previews !== undefined) {
        o['previews'] = m.previews.map(e => storePricePreviewsToJson(e));
    }
    return o;
}
export function listStorePricePreviewsResponseFromJson(o) {
    var _a;
    return {
        previews: ((_a = o['previews']) !== null && _a !== void 0 ? _a : []).map(e => storePricePreviewsFromJson(e)),
    };
}
export function getMultiStorePricePreviewsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.productIds !== undefined) {
        o['productIds'] = m.productIds.map(e => e);
    }
    return o;
}
export function getMultiStorePricePreviewsRequestFromJson(o) {
    var _a, _b;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        productIds: ((_b = o['productIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function getMultiStorePricePreviewsResponseToJson(m) {
    const o = {};
    if (m.productPreviews !== undefined) {
        o['productPreviews'] = m.productPreviews.map(e => productPricePreviewsToJson(e));
    }
    return o;
}
export function getMultiStorePricePreviewsResponseFromJson(o) {
    var _a;
    return {
        productPreviews: ((_a = o['productPreviews']) !== null && _a !== void 0 ? _a : []).map(e => productPricePreviewsFromJson(e)),
    };
}
export function listStoreProductVisibilitySummariesRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function listStoreProductVisibilitySummariesRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listStoreProductVisibilitySummariesResponseToJson(m) {
    const o = {};
    if (m.summaries !== undefined) {
        const map = {};
        for (const [k, v] of Object.entries(m.summaries)) {
            map[k] = listStoreProductVisibilitySummariesResponseStoreProductVisibilitySummaryToJson(v);
        }
        o['summaries'] = map;
    }
    return o;
}
export function listStoreProductVisibilitySummariesResponseFromJson(o) {
    return {
        summaries: o['summaries']
            ? Object.fromEntries(Object.entries(o['summaries']).map(([k, v]) => [k, listStoreProductVisibilitySummariesResponseStoreProductVisibilitySummaryFromJson(v)]))
            : {},
    };
}
export function listStoreProductVisibilitySummariesResponseStoreProductVisibilitySummaryToJson(m) {
    const o = {};
    if (m.productId !== undefined)
        o['productId'] = m.productId;
    if (m.numStoresVisible !== undefined)
        o['numStoresVisible'] = m.numStoresVisible;
    return o;
}
export function listStoreProductVisibilitySummariesResponseStoreProductVisibilitySummaryFromJson(o) {
    var _a, _b;
    return {
        productId: (_a = o['productId']) !== null && _a !== void 0 ? _a : '',
        numStoresVisible: (_b = o['numStoresVisible']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function storeProductToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.tagline !== undefined)
        o['tagline'] = m.tagline;
    if (m.iconUrl !== undefined)
        o['iconUrl'] = m.iconUrl;
    if (m.headerImageUrl !== undefined)
        o['headerImageUrl'] = m.headerImageUrl;
    if (m.pricing !== undefined)
        o['pricing'] = pricingToJson(m.pricing);
    if (m.lmiCategories !== undefined) {
        o['lmiCategories'] = m.lmiCategories.map(e => e);
    }
    if (m.referenceId !== undefined) {
        if (m.referenceId.type === 'appId') {
            o['appId'] = m.referenceId.appId;
        }
        if (m.referenceId.type === 'packageId') {
            o['packageId'] = m.referenceId.packageId;
        }
    }
    else {
        if (m.appId !== undefined)
            o['appId'] = m.appId;
        if (m.packageId !== undefined)
            o['packageId'] = m.packageId;
    }
    return o;
}
export function storeProductFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        tagline: (_b = o['tagline']) !== null && _b !== void 0 ? _b : '',
        iconUrl: (_c = o['iconUrl']) !== null && _c !== void 0 ? _c : '',
        headerImageUrl: (_d = o['headerImageUrl']) !== null && _d !== void 0 ? _d : '',
        pricing: o['pricing'] ? pricingFromJson(o['pricing']) : undefined,
        lmiCategories: ((_e = o['lmiCategories']) !== null && _e !== void 0 ? _e : []).map(e => e),
        referenceId: (() => {
            if (o['appId'] !== undefined)
                return { type: 'appId', appId: o['appId'] };
            if (o['packageId'] !== undefined)
                return { type: 'packageId', packageId: o['packageId'] };
            return undefined;
        })(),
        appId: o['appId'] !== undefined ? o['appId'] : undefined,
        packageId: o['packageId'] !== undefined ? o['packageId'] : undefined,
    };
}
export function listProductsInStoreFiltersToJson(m) {
    const o = {};
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function listProductsInStoreFiltersFromJson(o) {
    var _a;
    return {
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
    };
}
export function listProductsInStoreRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.filters !== undefined)
        o['filters'] = listProductsInStoreFiltersToJson(m.filters);
    return o;
}
export function listProductsInStoreRequestFromJson(o) {
    var _a, _b;
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        cursor: (_a = o['cursor']) !== null && _a !== void 0 ? _a : '',
        pageSize: (_b = o['pageSize']) !== null && _b !== void 0 ? _b : 0,
        filters: o['filters'] ? listProductsInStoreFiltersFromJson(o['filters']) : undefined,
    };
}
export function listProductsInStoreResponseToJson(m) {
    const o = {};
    if (m.storeProducts !== undefined) {
        o['storeProducts'] = m.storeProducts.map(e => storeProductToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listProductsInStoreResponseFromJson(o) {
    var _a, _b, _c;
    return {
        storeProducts: ((_a = o['storeProducts']) !== null && _a !== void 0 ? _a : []).map(e => storeProductFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function listVisibleAddonsForProductRequestToJson(m) {
    const o = {};
    if (m.appId !== undefined)
        o['appId'] = m.appId;
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    return o;
}
export function listVisibleAddonsForProductRequestFromJson(o) {
    var _a, _b, _c;
    return {
        appId: (_a = o['appId']) !== null && _a !== void 0 ? _a : '',
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        pageSize: (_c = o['pageSize']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function listVisibleAddonsForProductResponseToJson(m) {
    const o = {};
    if (m.storeProducts !== undefined) {
        o['storeProducts'] = m.storeProducts.map(e => storeProductToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listVisibleAddonsForProductResponseFromJson(o) {
    var _a, _b, _c;
    return {
        storeProducts: ((_a = o['storeProducts']) !== null && _a !== void 0 ? _a : []).map(e => storeProductFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function hasPartnerSetStoreOrderRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function hasPartnerSetStoreOrderRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function hasPartnerSetStoreOrderResponseToJson(m) {
    const o = {};
    if (m.result !== undefined)
        o['result'] = m.result;
    return o;
}
export function hasPartnerSetStoreOrderResponseFromJson(o) {
    var _a;
    return {
        result: (_a = o['result']) !== null && _a !== void 0 ? _a : false,
    };
}
export function getPublicStoreSalespersonRequestToJson(m) {
    const o = {};
    if (m.storeId !== undefined)
        o['storeId'] = storeIdentifierToJson(m.storeId);
    return o;
}
export function getPublicStoreSalespersonRequestFromJson(o) {
    return {
        storeId: o['storeId'] ? storeIdentifierFromJson(o['storeId']) : undefined,
    };
}
export function getPublicStoreSalespersonResponseToJson(m) {
    const o = {};
    if (m.salesperson !== undefined)
        o['salesperson'] = salespersonToJson(m.salesperson);
    return o;
}
export function getPublicStoreSalespersonResponseFromJson(o) {
    return {
        salesperson: o['salesperson'] ? salespersonFromJson(o['salesperson']) : undefined,
    };
}
export function salespersonToJson(m) {
    const o = {};
    if (m.salesPersonId !== undefined)
        o['salesPersonId'] = m.salesPersonId;
    if (m.firstName !== undefined)
        o['firstName'] = m.firstName;
    if (m.lastName !== undefined)
        o['lastName'] = m.lastName;
    if (m.jobTitle !== undefined)
        o['jobTitle'] = m.jobTitle;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.phoneNumber !== undefined) {
        o['phoneNumber'] = m.phoneNumber.map(e => e);
    }
    if (m.photoUrl !== undefined)
        o['photoUrl'] = m.photoUrl;
    if (m.photoUrlSecure !== undefined)
        o['photoUrlSecure'] = m.photoUrlSecure;
    return o;
}
export function salespersonFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        salesPersonId: (_a = o['salesPersonId']) !== null && _a !== void 0 ? _a : '',
        firstName: (_b = o['firstName']) !== null && _b !== void 0 ? _b : '',
        lastName: (_c = o['lastName']) !== null && _c !== void 0 ? _c : '',
        jobTitle: (_d = o['jobTitle']) !== null && _d !== void 0 ? _d : '',
        email: (_e = o['email']) !== null && _e !== void 0 ? _e : '',
        phoneNumber: ((_f = o['phoneNumber']) !== null && _f !== void 0 ? _f : []).map(e => e),
        photoUrl: (_g = o['photoUrl']) !== null && _g !== void 0 ? _g : '',
        photoUrlSecure: (_h = o['photoUrlSecure']) !== null && _h !== void 0 ? _h : '',
    };
}
